'use strict'

import {
  decorateLeafletPathDualDash,
  installLeafletDrawDualDashPreview
} from './portal-dual-dash.js'

const bindSeekUiHandlers = function ({
  _ = window._,
  $ = window.jQuery,
  L = window.L,
  $body = ($ ? $('body') : null),
  Swal = window.Swal,
  areaSwal = Swal,
  fnT = function (key) { return String(key || '') },
  fnTF = function (key) { return String(key || '') },
  fnGetMissionState = function () { return null },
  fnGetMap = function () { return null },
  fnGetDrawnItems = function () { return null },
  fnGetSeekDrawActive = function () { return false },
  fnSetSeekMode = function () {},
  fnSetSeekDrawActive = function () {},
  fnSetSeekDrawLine = function () {},
  fnSetSeekAxisCallback = function () {},
  fnSetSeekAxisUpBearingLast = function () {},
  fnResolveSeekAxisUpBearing = function () { return NaN },
  fnBuildSeekRowCandidates = function () { return [] },
  fnPickSeekRowCandidate = function () { return null },
  fnEstimateSeekCloneDistance = function () { return 10 },
  fnCloneSeekRow = function () { return null },
  fnCreateSeekAxisLayer = function () { return null },
  fnGetImportWaypointsCenter = function () { return null },
  fnCaptureState = function () { return null },
  fnUpdatePointCoordinates = function () {},
  fnBuildPointCoordinatesText = function () { return '' },
  fnTemplateSupportsPointCoordinatesField = function () { return false },
  fnUpdatePointXmlByPath = function () {},
  fnRefreshImportLine = function () {},
  fnHistoryPush = function () {},
  fnEmitShadowCreateRequest = function (payload) {
    if (typeof document === 'undefined' || typeof window.CustomEvent !== 'function') return
    document.dispatchEvent(new window.CustomEvent('portal:shadow-create', { detail: payload || {} }))
  },
  roundToTenth = function (value) { return Number(value) || 0 },
  normalizeBearingDeg = function (value) { return Number(value) || 0 },
  offsetLatLngByMeters = function (lat, lng) { return { lat: lat, lng: lng } }
} = {}) {

  if (!$ || !L || !$body || !Swal || !areaSwal) return

  const fnRotateLatLngAroundCenter = function (lat, lng, centerLatLng, angleDeg) {
    const map = fnGetMap()
    if (!map || !centerLatLng || !Number.isFinite(angleDeg)) return { lat: lat, lng: lng }
    const zoom = (typeof map.getZoom === 'function') ? map.getZoom() : 0
    const p = map.project(L.latLng(lat, lng), zoom)
    const c = map.project(centerLatLng, zoom)
    const rad = angleDeg * (Math.PI / 180)
    const cosA = Math.cos(rad)
    const sinA = Math.sin(rad)
    const dx = p.x - c.x
    const dy = p.y - c.y
    const rotated = L.point(
      c.x + (dx * cosA) - (dy * sinA),
      c.y + (dx * sinA) + (dy * cosA)
    )
    const ll = map.unproject(rotated, zoom)
    return { lat: ll.lat, lng: ll.lng }
  }

  const fnRotateAxisLayerAroundCenter = function (layer, centerLatLng, angleDeg) {
    if (!layer || !layer.getLatLngs || !layer.setLatLngs) return
    if (!centerLatLng || !Number.isFinite(angleDeg)) return
    const latlngs = layer.getLatLngs()
    if (!latlngs || latlngs.length < 2) return
    const rotated = latlngs.map(function (ll) {
      const next = fnRotateLatLngAroundCenter(ll.lat, ll.lng, centerLatLng, angleDeg)
      return L.latLng(next.lat, next.lng)
    })
    layer.setLatLngs(rotated)
  }

  const fnResolveAxisLayerMidpointLatLng = function (layer) {
    const latlngs = layer && layer.getLatLngs ? layer.getLatLngs() : []
    if (!latlngs || latlngs.length < 2) return null
    const first = latlngs[0]
    const last = latlngs[latlngs.length - 1]
    return L.latLng(
      (Number(first.lat) + Number(last.lat)) / 2,
      (Number(first.lng) + Number(last.lng)) / 2
    )
  }

  $body.find('[data-leaf-seek]')
    .off('click.portalSeek')
    .on('click.portalSeek', function () {
      const missionState = fnGetMissionState()
      if (!missionState || !missionState.waypoints || !missionState.waypoints.length) {
        Swal.fire(fnT('seek.no_movable_point'))
        return
      }
      const map = fnGetMap()
      if (!map) return
      if (fnGetSeekDrawActive()) return

      const fnStartSeekAxisManualDraw = function (onAxisReady) {
        if (fnGetSeekDrawActive()) return
        Swal.fire({
          toast: true,
          position: 'bottom',
          customClass: {
            popup: 'swal-toast-bottom-center'
          },
          icon: 'info',
          title: fnT('seek.redraw_axis_title'),
          timer: 1800,
          timerProgressBar: true,
          showConfirmButton: false
        })
        fnSetSeekMode(true)
        fnSetSeekDrawActive(true)
        fnSetSeekAxisCallback(function (axisLayer) {
          decorateLeafletPathDualDash(axisLayer, { L: L })
          const latlngs = axisLayer && axisLayer.getLatLngs ? axisLayer.getLatLngs() : []
          if (!latlngs || latlngs.length < 2) {
            Swal.fire(fnT('seek.axis_need_two_points'))
            return
          }
          if (typeof onAxisReady === 'function') onAxisReady(axisLayer)
        })
        map.once('draw:drawstop', function () {
          setTimeout(function () {
            if (fnGetSeekDrawActive()) {
              fnSetSeekMode(false)
              fnSetSeekDrawActive(false)
              fnSetSeekDrawLine(null)
              fnSetSeekAxisCallback(null)
            }
          }, 0)
        })
        const drawLine = new L.Draw.Polyline(map, {
          shapeOptions: {
            color: '#0d6efd',
            weight: 3,
            dashArray: '6,6'
          },
          maxPoints: 2,
          repeatMode: false
        })
        fnSetSeekDrawLine(drawLine)
        drawLine.enable()
        installLeafletDrawDualDashPreview({
          L: L,
          map: map,
          drawLayer: drawLine
        })
      }

      const fnOpenSeekPopupForAxis = function (axisLayer) {
        if (!axisLayer) return
        let axisUpBearing = fnResolveSeekAxisUpBearing(axisLayer)
        if (!Number.isFinite(axisUpBearing)) {
          Swal.fire(fnT('seek.auto_axis_unknown'))
          return
        }
        fnSetSeekAxisUpBearingLast(axisUpBearing)
        const drawnItems = fnGetDrawnItems()
        if (!drawnItems) return
        drawnItems.addLayer(axisLayer)
        drawnItems.addTo(map)
        let selectedRowLayer = null
        let selectedMode = 'first'
        let selectedCandidate = null
        let rowCandidates = []
        let rotateCenterMarker = null

        const fnBuildRedCenterMarkerIcon = function () {
          return L.divIcon({
            className: '',
            iconSize: [14, 14],
            iconAnchor: [7, 7],
            html: '<span style="display:block;width:14px;height:14px;border-radius:50%;background:#dc3545;border:2px solid #ffffff;box-shadow:0 0 0 1px rgba(0,0,0,0.35);"></span>'
          })
        }

        const removeAxisLayer = function () {
          if (axisLayer && drawnItems && drawnItems.hasLayer(axisLayer)) {
            drawnItems.removeLayer(axisLayer)
          }
          if (selectedRowLayer && drawnItems && drawnItems.hasLayer(selectedRowLayer)) {
            drawnItems.removeLayer(selectedRowLayer)
          }
          if (rotateCenterMarker && map && map.hasLayer(rotateCenterMarker)) {
            map.removeLayer(rotateCenterMarker)
          }
          selectedRowLayer = null
          rotateCenterMarker = null
        }

        const fnUpdateRowInfo = function ($modal, candidate) {
          const $info = $modal.find('[data-seek-row-info]')
          if (!$info.length) return
          if (!candidate) {
            $info.text(fnT('seek.no_selected_row'))
            return
          }
          const typeText = candidate.isLong ? fnT('seek.row_type_long') : fnT('seek.row_type_short')
          $info.text(fnTF('seek.selected_row', {
            from: (candidate.fromIndex + 1),
            to: (candidate.toIndex + 1),
            type: typeText,
            distance: candidate.distance.toFixed(1)
          }))
        }

        const fnSetSelectedRowVisual = function (candidate) {
          if (selectedRowLayer && drawnItems && drawnItems.hasLayer(selectedRowLayer)) {
            drawnItems.removeLayer(selectedRowLayer)
          }
          selectedRowLayer = null
          if (!candidate) return
          selectedRowLayer = L.polyline([candidate.fromLatLng, candidate.toLatLng], {
            color: '#fd7e14',
            weight: 5,
            opacity: 0.95
          })
          drawnItems.addLayer(selectedRowLayer)
          drawnItems.addTo(map)
        }

        const fnSetSelectedModeButtons = function ($modal) {
          const $first = $modal.find('[data-seek-select-row="first"]')
          const $last = $modal.find('[data-seek-select-row="last"]')
          const firstActive = selectedMode === 'first'
          const lastActive = selectedMode === 'last'
          $first.attr('data-seek-selected', firstActive ? 'true' : 'false')
          $last.attr('data-seek-selected', lastActive ? 'true' : 'false')
        }
        const fnIsSplitRowDetectionEnabled = function ($modal) {
          const $checkbox = $modal.find('[data-seek-axis-split-detect]')
          if (!$checkbox.length) return true
          return $checkbox.is(':checked')
        }
        const fnResolveAxisAnchorLatLng = function () {
          const latlngs = axisLayer && axisLayer.getLatLngs ? axisLayer.getLatLngs() : []
          if (!latlngs || latlngs.length < 2) {
            return fnGetImportWaypointsCenter() || (map ? map.getCenter() : null)
          }
          const first = latlngs[0]
          const last = latlngs[latlngs.length - 1]
          return L.latLng(
            (Number(first.lat) + Number(last.lat)) / 2,
            (Number(first.lng) + Number(last.lng)) / 2
          )
        }
        const fnApplyAutoAxisByMode = function ($modal) {
          const useSplitDetect = fnIsSplitRowDetectionEnabled($modal)
          const anchorLatLng = fnResolveAxisAnchorLatLng()
          const nextAxisLayer = fnCreateSeekAxisLayer(anchorLatLng, {
            detectSplitRows: useSplitDetect,
            ignoreAxisUpBearingLast: true,
            forceAutoAxis: true
          })
          if (!nextAxisLayer) return false
          if (axisLayer && drawnItems && drawnItems.hasLayer(axisLayer)) {
            drawnItems.removeLayer(axisLayer)
          }
          axisLayer = nextAxisLayer
          drawnItems.addLayer(axisLayer)
          const resolvedBearing = fnResolveSeekAxisUpBearing(axisLayer)
          if (!Number.isFinite(resolvedBearing)) return false
          axisUpBearing = normalizeBearingDeg(resolvedBearing)
          fnSetSeekAxisUpBearingLast(axisUpBearing)
          fnRefreshRowState($modal, { updateCloneDefault: true })
          return true
        }

        const fnRefreshRowState = function ($modal, refreshOpts) {
          const options = (_.assign || Object.assign)({ updateCloneDefault: false }, refreshOpts || {})
          rowCandidates = fnBuildSeekRowCandidates(axisUpBearing)
          selectedCandidate = fnPickSeekRowCandidate(rowCandidates, selectedMode)
          fnSetSelectedRowVisual(selectedCandidate)
          fnSetSelectedModeButtons($modal)
          fnUpdateRowInfo($modal, selectedCandidate)
          if (options.updateCloneDefault) {
            const suggested = fnEstimateSeekCloneDistance(rowCandidates, axisUpBearing)
            $modal.find('[data-seek-clone-distance]').val(roundToTenth(suggested).toFixed(1))
          }
        }

        const fnReadCloneDistance = function ($modal) {
          const raw = String($modal.find('[data-seek-clone-distance]').val() || '').trim()
          const value = parseFloat(raw)
          if (!Number.isFinite(value) || value <= 0) return NaN
          return Math.max(0.1, roundToTenth(value))
        }
        const fnGetRotateCenterLatLng = function () {
          if (rotateCenterMarker && rotateCenterMarker.getLatLng) {
            return rotateCenterMarker.getLatLng()
          }
          return map ? map.getCenter() : null
        }
        const fnApplySeekRotation = function ($modal, direction) {
          const raw = String($modal.find('[data-seek-rotate-distance]').val() || '').trim()
          const angle = raw === '' ? NaN : parseFloat(raw)
          if (!(Number.isFinite(angle) && angle > 0)) {
            Swal.showValidationMessage(fnT('validate.positive_rotation_angle'))
            return false
          }
          const signedAngle = direction === 'cw' ? angle : (-angle)
          const centerLatLng = fnGetRotateCenterLatLng()
          if (!centerLatLng) {
            Swal.showValidationMessage(fnT('validate.rotation_center_unavailable'))
            return false
          }
          const historyBefore = fnCaptureState()
          const missionState = fnGetMissionState()
          if (!missionState || !Array.isArray(missionState.waypoints)) return false
          missionState.waypoints.forEach(function (pt) {
            const rotated = fnRotateLatLngAroundCenter(pt.latlng[0], pt.latlng[1], centerLatLng, signedAngle)
            pt.latlng = [rotated.lat, rotated.lng]
            if (pt.props && pt.props.coordinates) {
              pt.props.coordinates.lat = rotated.lat
              pt.props.coordinates.lng = rotated.lng
            }
            if (pt.marker) {
              pt.marker.setLatLng(pt.latlng)
            }
            fnUpdatePointCoordinates(pt, rotated.lat, rotated.lng)
            const pointCoordinatesText = fnBuildPointCoordinatesText(pt.props || {})
            if (fnTemplateSupportsPointCoordinatesField()) {
              fnUpdatePointXmlByPath(pt, 'Point.coordinates', pointCoordinatesText)
            }
          })
          fnRefreshImportLine()
          fnHistoryPush(historyBefore)
          fnRotateAxisLayerAroundCenter(axisLayer, centerLatLng, signedAngle)
          const resolvedBearing = axisLayer ? fnResolveSeekAxisUpBearing(axisLayer) : NaN
          if (Number.isFinite(resolvedBearing)) {
            axisUpBearing = normalizeBearingDeg(resolvedBearing)
            fnSetSeekAxisUpBearingLast(axisUpBearing)
          }
          fnRefreshRowState($modal, { updateCloneDefault: false })
          return true
        }
        const fnRotateSeekAxisQuarterTurn = function ($modal) {
          const centerLatLng = fnResolveAxisLayerMidpointLatLng(axisLayer)
          if (!centerLatLng) {
            Swal.showValidationMessage(fnT('seek.axis_not_computable'))
            return false
          }
          fnRotateAxisLayerAroundCenter(axisLayer, centerLatLng, 90)
          const resolvedBearing = axisLayer ? fnResolveSeekAxisUpBearing(axisLayer) : NaN
          if (!Number.isFinite(resolvedBearing)) {
            Swal.showValidationMessage(fnT('seek.axis_not_computable'))
            return false
          }
          axisUpBearing = normalizeBearingDeg(resolvedBearing)
          fnSetSeekAxisUpBearingLast(axisUpBearing)
          fnRefreshRowState($modal, { updateCloneDefault: true })
          return true
        }
        const fnRotateSeekAxisToGrid = function ($modal) {
          const centerLatLng = fnResolveAxisLayerMidpointLatLng(axisLayer)
          if (!centerLatLng) {
            Swal.showValidationMessage(fnT('seek.axis_not_computable'))
            return false
          }
          const gridHelper = (typeof window !== 'undefined' && window.PORTAL_GRID_HELPER)
            ? window.PORTAL_GRID_HELPER
            : null
          if (!gridHelper || typeof gridHelper.getNearestAxisBearing !== 'function') {
            Swal.showValidationMessage(fnT('seek.grid_unavailable'))
            return false
          }
          const targetBearing = Number(gridHelper.getNearestAxisBearing(axisUpBearing))
          if (!Number.isFinite(targetBearing)) {
            Swal.showValidationMessage(fnT('seek.grid_unavailable'))
            return false
          }
          const rotationDelta = ((targetBearing - axisUpBearing + 540) % 360) - 180
          if (Math.abs(rotationDelta) < 0.000001) {
            return true
          }
          fnRotateAxisLayerAroundCenter(axisLayer, centerLatLng, rotationDelta)
          const resolvedBearing = axisLayer ? fnResolveSeekAxisUpBearing(axisLayer) : NaN
          if (!Number.isFinite(resolvedBearing)) {
            Swal.showValidationMessage(fnT('seek.axis_not_computable'))
            return false
          }
          axisUpBearing = normalizeBearingDeg(resolvedBearing)
          fnSetSeekAxisUpBearingLast(axisUpBearing)
          fnRefreshRowState($modal, { updateCloneDefault: true })
          return true
        }
        const fnApplySeekOffset = function ($modal, direction) {
          const raw = String($modal.find('[data-seek-distance]').val() || '').trim()
          const meters = raw === '' ? NaN : parseFloat(raw)
          const normalizedDirection = direction === 'down' ? 'down' : 'up'
          const bearing = normalizedDirection === 'down' ? ((axisUpBearing + 180) % 360) : axisUpBearing
          if (!(Number.isFinite(meters) && meters > 0)) {
            Swal.showValidationMessage(fnT('validate.positive_distance'))
            return false
          }
          if (!Number.isFinite(bearing)) {
            Swal.showValidationMessage(fnT('validate.offset_direction_unknown'))
            return false
          }
          const historyBefore = fnCaptureState()
          const missionState = fnGetMissionState()
          if (!missionState || !Array.isArray(missionState.waypoints)) return false
          missionState.waypoints.forEach(function (pt) {
            const moved = offsetLatLngByMeters(pt.latlng[0], pt.latlng[1], meters, bearing)
            pt.latlng = [moved.lat, moved.lng]
            if (pt.props && pt.props.coordinates) {
              pt.props.coordinates.lat = moved.lat
              pt.props.coordinates.lng = moved.lng
            }
            if (pt.marker) {
              pt.marker.setLatLng(pt.latlng)
            }
            fnUpdatePointCoordinates(pt, moved.lat, moved.lng)
            const pointCoordinatesText = fnBuildPointCoordinatesText(pt.props || {})
            if (fnTemplateSupportsPointCoordinatesField()) {
              fnUpdatePointXmlByPath(pt, 'Point.coordinates', pointCoordinatesText)
            }
          })
          fnRefreshImportLine()
          fnHistoryPush(historyBefore)
          return true
        }

        const tpl = $('[data-tpl-seek-points-popup]').html() || ''
        const footerTpl = $('[data-tpl-seek-extra-actions]').html() || ''
        areaSwal.fire({
          title: fnT('seek.title'),
          width: 560,
          position: 'bottom-right',
          backdrop: false,
          showCancelButton: false,
          showDenyButton: false,
          showConfirmButton: false,
          footer: ' ',
          customClass: {
            popup: 'swal-seek-bottom-panel'
          },
          html: tpl,
          didOpen: function (modal) {
            const $modal = $(modal)
            const footerEl = modal && modal.querySelector ? modal.querySelector('.swal2-actions.modal-footer') : null
            if (footerEl) {
              footerEl.innerHTML = footerTpl
            }
            const rotateCenter = fnGetImportWaypointsCenter() || (map ? map.getCenter() : null)
            if (rotateCenter) {
              rotateCenterMarker = L.marker(rotateCenter, {
                draggable: true,
                zIndexOffset: 900,
                icon: fnBuildRedCenterMarkerIcon()
              })
              rotateCenterMarker.bindTooltip(fnT('seek.rotate_center_tooltip'), {
                direction: 'top',
                sticky: true
              })
              rotateCenterMarker.addTo(map)
            }
            $modal.find('[data-seek-rotate]').on('click', function () {
              const direction = String($(this).data('seekRotate') || '') === 'cw' ? 'cw' : 'ccw'
              fnApplySeekRotation($modal, direction)
            })
            const $cloneDistance = $modal.find('[data-seek-clone-distance]')
            $modal.find('[data-seek-axis-split-detect]').on('change', function () {
              const ok = fnApplyAutoAxisByMode($modal)
              if (!ok) {
                Swal.showValidationMessage(fnT('seek.axis_not_computable'))
              }
            })
            $modal.find('[data-seek-direction]').on('click', function () {
              const direction = String($(this).data('seekDirection') || '') === 'down' ? 'down' : 'up'
              fnApplySeekOffset($modal, direction)
            })
            $modal.find('[data-clone-step]').on('click', function () {
              const step = parseFloat(String($(this).data('cloneStep') || '0'))
              const cur = parseFloat(String($cloneDistance.val() || ''))
              const base = Number.isFinite(cur) ? cur : 10
              const next = Math.max(0.1, roundToTenth(base + step))
              $cloneDistance.val(next.toFixed(1))
            })
            $modal.find('[data-seek-select-row]').on('click', function () {
              selectedMode = String($(this).data('seekSelectRow') || '') === 'last' ? 'last' : 'first'
              fnRefreshRowState($modal, { updateCloneDefault: false })
            })
            $modal.find('[data-seek-clone]').on('click', function () {
              const target = String($(this).data('seekClone') || '') === 'last' ? 'last' : 'first'
              const cloneDistance = fnReadCloneDistance($modal)
              if (!(cloneDistance > 0)) {
                Swal.showValidationMessage(fnT('validate.clone_distance_positive'))
                return
              }
              if (!selectedCandidate) {
                Swal.showValidationMessage(fnT('validate.select_row'))
                return
              }
              const cloned = fnCloneSeekRow(selectedCandidate, axisUpBearing, target, cloneDistance, selectedMode)
              if (!cloned) {
                Swal.showValidationMessage(fnT('validate.clone_row_failed'))
                return
              }
              fnRefreshRowState($modal, { updateCloneDefault: false })
            })
            $(modal).on('click', '[data-seek-redraw-axis]', function () {
              areaSwal.close()
              removeAxisLayer()
              fnStartSeekAxisManualDraw(function (newAxisLayer) {
                fnOpenSeekPopupForAxis(newAxisLayer)
              })
            })
            $(modal).on('click', '[data-seek-rotate-to-grid]', function () {
              fnRotateSeekAxisToGrid($modal)
            })
            $(modal).on('click', '[data-seek-rotate-axis-quarter]', function () {
              fnRotateSeekAxisQuarterTurn($modal)
            })
            $(modal).on('click', '[data-seek-cancel]', function () {
              areaSwal.close()
            })
            fnRefreshRowState($modal, { updateCloneDefault: true })
          }
        }).finally(function () {
          removeAxisLayer()
        })
      }

      const autoAxisLayer = fnCreateSeekAxisLayer(null, {
        detectSplitRows: true
      })
      if (!autoAxisLayer) {
        Swal.fire(fnT('seek.axis_not_computable'))
        fnStartSeekAxisManualDraw(function (manualAxisLayer) {
          fnOpenSeekPopupForAxis(manualAxisLayer)
        })
        return
      }
      fnOpenSeekPopupForAxis(autoAxisLayer)
    })

  const SHADOW_DEFAULTS = {
    mode: 'auto',
    gimbalPitchDeg: -50,
    rowSpacingM: 3.5,
    rowHeightM: 3.5,
    vfovDeg: 9,
    targetRows: 3,
    edgeMarginRatio: 1 / 3
  }

  const fnClampShadowTargetRows = function (value) {
    const n = Math.round(Number(value))
    if (!Number.isFinite(n)) return SHADOW_DEFAULTS.targetRows
    return Math.max(1, Math.min(12, n))
  }

  const fnIsShadowLocalProviderActive = function () {
    if (typeof window === 'undefined') return false
    const localState = window.PORTAL_LOCAL_TERRAIN_STATE
    return !!(
      localState &&
      localState.active === true &&
      (
        typeof localState.sampleElevation === 'function' ||
        typeof localState.sampleElevationAsync === 'function' ||
        typeof localState.sampleElevations === 'function'
      )
    )
  }

  const fnBuildShadowDemProviderKeys = function () {
    const out = ['']
    if (fnIsShadowLocalProviderActive()) out.push('localDEM')
    const priority = (typeof window !== 'undefined' && Array.isArray(window.PORTAL_DEM_PROVIDER_PRIORITY))
      ? window.PORTAL_DEM_PROVIDER_PRIORITY
      : []
    priority.forEach(function (providerKey) {
      const key = String(providerKey || '').trim()
      if (!key || out.includes(key)) return
      out.push(key)
    })
    return out
  }

  const fnGetShadowDemProviderLabel = function (providerKey) {
    const key = String(providerKey || '').trim()
    if (!key) return '-- DEM nélkül --'
    if (typeof window !== 'undefined' && typeof window.PORTAL_GET_DEM_PROVIDER_LABEL === 'function') {
      const label = String(window.PORTAL_GET_DEM_PROVIDER_LABEL(key) || '').trim()
      if (label) return label
    }
    return key
  }

  const fnToFiniteShadowElevationOrNull = function (value) {
    if (value === null || value === undefined) return null
    if (typeof value === 'string' && !String(value).trim()) return null
    const numericValue = Number(value)
    return Number.isFinite(numericValue) ? numericValue : null
  }

  const fnResolveShadowFallbackProviderKey = function (providerKey) {
    const primaryKey = String(providerKey || '').trim()
    if (!primaryKey) return ''
    const providerKeys = fnBuildShadowDemProviderKeys().filter(function (key) {
      return !!String(key || '').trim()
    })
    const explicitFallbackKey = (typeof window !== 'undefined' && typeof window.PORTAL_GET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER === 'function')
      ? String(window.PORTAL_GET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER() || '').trim()
      : String((typeof window !== 'undefined' && window.PORTAL_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER) || '').trim()
    if (explicitFallbackKey && explicitFallbackKey !== primaryKey && providerKeys.includes(explicitFallbackKey)) {
      return explicitFallbackKey
    }
    return providerKeys.find(function (key) {
      return key !== primaryKey
    }) || ''
  }

  const fnLogShadowDemDebug = function (level, label, payload) {
    if (typeof console === 'undefined') return
    const method = (typeof console[level] === 'function') ? console[level].bind(console) : (typeof console.log === 'function' ? console.log.bind(console) : null)
    if (!method) return
    try {
      method(`${String(label || '[shadow-dem]').trim()} ${JSON.stringify(payload && typeof payload === 'object' ? payload : {})}`)
    } catch (_error) {
      method(String(label || '[shadow-dem]').trim())
    }
  }

  const fnIsShadowDemDeepDebugEnabled = function () {
    return typeof window !== 'undefined' && window.PORTAL_DEBUG_SHADOW_DEM === true
  }

  const fnLogShadowDemDebugHintOnce = function () {
    if (typeof window === 'undefined') return
    if (window.PORTAL_SHADOW_DEM_DEBUG_HINT_LOGGED === true) return
    if (typeof console === 'undefined' || typeof console.log !== 'function') return
    window.PORTAL_SHADOW_DEM_DEBUG_HINT_LOGGED = true
    console.log('PORTAL_DEBUG_SHADOW_DEM available. Enable with: window.PORTAL_DEBUG_SHADOW_DEM = true')
  }

  const fnRoundShadowDebugNumber = function (value, digits) {
    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) return null
    const precision = Number.isFinite(Number(digits)) ? Math.max(0, Number(digits)) : 3
    const factor = 10 ** precision
    return Math.round(numericValue * factor) / factor
  }

  const fnBuildShadowDemProfileDebugSummary = function (profile) {
    const normalizedProfile = fnTryNormalizeShadowTerrainProfile(profile)
    if (!normalizedProfile) return null
    const samples = Array.isArray(normalizedProfile.samples) ? normalizedProfile.samples : []
    const transitions = []
    const deltaRows = []
    const focusIndexes = new Set()
    samples.forEach(function (row, idx) {
      const currentY = fnToFiniteShadowElevationOrNull(row && row.y)
      const previous = idx > 0 ? samples[idx - 1] : null
      const previousY = fnToFiniteShadowElevationOrNull(previous && previous.y)
      const currentProvider = String((row && row.provider) || '').trim()
      const previousProvider = String((previous && previous.provider) || '').trim()
      if (idx > 0 && currentY !== null && previousY !== null) {
        const deltaY = currentY - previousY
        deltaRows.push({
          fromIdx: idx - 1,
          toIdx: idx,
          fromProvider: previousProvider,
          toProvider: currentProvider,
          deltaY: fnRoundShadowDebugNumber(deltaY, 3)
        })
        if (previousProvider !== currentProvider) {
          transitions.push({
            fromIdx: idx - 1,
            toIdx: idx,
            fromProvider: previousProvider,
            toProvider: currentProvider,
            deltaY: fnRoundShadowDebugNumber(deltaY, 3)
          })
          focusIndexes.add(idx - 1)
          focusIndexes.add(idx)
        }
      }
    })
    deltaRows
      .slice()
      .sort(function (a, b) {
        return Math.abs(Number(b && b.deltaY)) - Math.abs(Number(a && a.deltaY))
      })
      .slice(0, 6)
      .forEach(function (row) {
        if (!row) return
        focusIndexes.add(Number(row.fromIdx))
        focusIndexes.add(Number(row.toIdx))
      })
    const focusRows = samples.filter(function (_row, idx) {
      return focusIndexes.has(idx)
    }).map(function (row, idx) {
      const originalIndex = samples.indexOf(row)
      return {
        order: idx,
        idx: Number(row && row.idx),
        sampleIdx: originalIndex,
        x: fnRoundShadowDebugNumber(row && row.x, 3),
        y: fnRoundShadowDebugNumber(row && row.y, 3),
        elevation: fnRoundShadowDebugNumber(row && row.elevation, 3),
        provider: String((row && row.provider) || '').trim(),
        lat: fnRoundShadowDebugNumber(row && row.lat, 8),
        lng: fnRoundShadowDebugNumber(row && row.lng, 8)
      }
    })
    const yValues = samples.map(function (row) {
      return fnToFiniteShadowElevationOrNull(row && row.y)
    }).filter(function (value) {
      return value !== null
    })
    const elevationValues = samples.map(function (row) {
      return fnToFiniteShadowElevationOrNull(row && row.elevation)
    }).filter(function (value) {
      return value !== null
    })
    return {
      providerKey: String(normalizedProfile && normalizedProfile.providerKey || '').trim(),
      sampleCount: samples.length,
      pointCount: Array.isArray(normalizedProfile.points) ? normalizedProfile.points.length : 0,
      minY: yValues.length ? fnRoundShadowDebugNumber(Math.min.apply(null, yValues), 3) : null,
      maxY: yValues.length ? fnRoundShadowDebugNumber(Math.max.apply(null, yValues), 3) : null,
      minElevation: elevationValues.length ? fnRoundShadowDebugNumber(Math.min.apply(null, elevationValues), 3) : null,
      maxElevation: elevationValues.length ? fnRoundShadowDebugNumber(Math.max.apply(null, elevationValues), 3) : null,
      transitions: transitions,
      largestDeltas: deltaRows
        .slice()
        .sort(function (a, b) {
          return Math.abs(Number(b && b.deltaY)) - Math.abs(Number(a && a.deltaY))
        })
        .slice(0, 6),
      focusRows: focusRows
    }
  }

  fnLogShadowDemDebugHintOnce()

  const fnPopulateShadowDemProviderSelect = function ($modal) {
    const $select = $modal.find('[data-shadow-dem-provider]')
    if (!$select.length) return ''
    const providerKeys = fnBuildShadowDemProviderKeys()
    const currentValue = String($select.val() || '').trim()
    const preferredValue = providerKeys.find(function (providerKey) { return !!String(providerKey || '').trim() }) || ''
    const hasInitialized = $select.attr('data-shadow-dem-provider-init') === '1'
    const selectedValue = (hasInitialized && providerKeys.includes(currentValue)) ? currentValue : preferredValue
    $select.empty()
    providerKeys.forEach(function (providerKey) {
      $('<option></option>')
        .attr('value', providerKey)
        .text(fnGetShadowDemProviderLabel(providerKey))
        .appendTo($select)
    })
    $select.val(selectedValue)
    $select.attr('data-shadow-dem-provider-init', '1')
    fnLogShadowDemDebug('log', '[shadow-dem] populate select', {
      providerKeys: providerKeys.slice(),
      selectedValue: selectedValue,
      selectedLabel: fnGetShadowDemProviderLabel(selectedValue),
      previousValue: currentValue,
      hasInitialized: hasInitialized
    })
    return selectedValue
  }

  const fnResolveShadowMode = function (value) {
    return String(value || '').trim().toLowerCase() === 'manual' ? 'manual' : 'auto'
  }

  const fnResolveShadowRowSpacing = function (axisUpBearing, detectSplitRows) {
    if (!Number.isFinite(axisUpBearing)) return NaN
    const rowCandidates = fnBuildSeekRowCandidates(axisUpBearing, { detectSplitRows: !!detectSplitRows })
    const spacing = fnEstimateSeekCloneDistance(rowCandidates, axisUpBearing)
    if (!Number.isFinite(spacing) || !(spacing > 0)) return NaN
    return roundToTenth(spacing)
  }

  const fnBuildShadowFlatTerrainProfile = function (xMin, xMax) {
    const minX = Number.isFinite(Number(xMin)) ? Number(xMin) : -1
    const maxX = Number.isFinite(Number(xMax)) ? Number(xMax) : 1
    const safeMaxX = maxX > minX ? maxX : (minX + 1)
    return {
      ready: true,
      providerKey: '',
      centerElevation: 0,
      samples: [
        { x: minX, y: 0, elevation: 0 },
        { x: safeMaxX, y: 0, elevation: 0 }
      ],
      points: [
        { x: minX, y: 0, elevation: 0 },
        { x: safeMaxX, y: 0, elevation: 0 }
      ]
    }
  }

  const fnTryNormalizeShadowTerrainProfile = function (profile) {
    const rawSamples = Array.isArray(profile && profile.samples)
      ? profile.samples
      : (Array.isArray(profile && profile.points) ? profile.points : [])
    const samples = rawSamples
      .map(function (row) {
        return {
          idx: Number(row && row.idx),
          x: Number(row && row.x),
          y: fnToFiniteShadowElevationOrNull(row && row.y),
          elevation: fnToFiniteShadowElevationOrNull(row && row.elevation),
          provider: String((row && row.provider) || '').trim(),
          lat: fnToFiniteShadowElevationOrNull(row && row.lat),
          lng: fnToFiniteShadowElevationOrNull(row && row.lng)
        }
      })
      .filter(function (row) {
        return Number.isFinite(row.x)
      })
      .sort(function (a, b) { return a.x - b.x })
    const points = samples.filter(function (row) {
      return row.y !== null
    }).map(function (row) {
      return {
        idx: Number(row && row.idx),
        x: row.x,
        y: row.y,
        elevation: row.elevation,
        provider: String((row && row.provider) || '').trim(),
        lat: fnToFiniteShadowElevationOrNull(row && row.lat),
        lng: fnToFiniteShadowElevationOrNull(row && row.lng)
      }
    })
    if (points.length >= 2) {
      return {
        ready: profile && profile.ready === true,
        providerKey: String(profile && profile.providerKey || '').trim(),
        centerElevation: Number.isFinite(Number(profile && profile.centerElevation)) ? Number(profile.centerElevation) : 0,
        samples: samples.map(function (row) {
          return {
            idx: Number(row && row.idx),
            x: row.x,
            y: row.y,
            elevation: row.elevation,
            provider: String((row && row.provider) || '').trim(),
            lat: fnToFiniteShadowElevationOrNull(row && row.lat),
            lng: fnToFiniteShadowElevationOrNull(row && row.lng)
          }
        }),
        points: points
      }
    }
    return null
  }

  const fnNormalizeShadowTerrainProfile = function (profile, fallbackXMin, fallbackXMax) {
    const normalizedProfile = fnTryNormalizeShadowTerrainProfile(profile)
    if (normalizedProfile) {
      return normalizedProfile
    }
    return fnBuildShadowFlatTerrainProfile(fallbackXMin, fallbackXMax)
  }

  const fnInterpolateShadowTerrainY = function (profile, x) {
    const terrainProfile = fnNormalizeShadowTerrainProfile(profile, x - 1, x + 1)
    const points = terrainProfile.points
    const xValue = Number(x)
    if (!Number.isFinite(xValue) || points.length < 2) return 0
    if (xValue <= points[0].x) return Number(points[0].y) || 0
    if (xValue >= points[points.length - 1].x) return Number(points[points.length - 1].y) || 0
    for (let i = 1; i < points.length; i += 1) {
      const prev = points[i - 1]
      const next = points[i]
      if (!(xValue >= prev.x && xValue <= next.x)) continue
      const span = next.x - prev.x
      if (!(Math.abs(span) > 1e-9)) return Number(prev.y) || 0
      const ratio = (xValue - prev.x) / span
      return prev.y + ((next.y - prev.y) * ratio)
    }
    return 0
  }

  const fnMeasureShadowTerrainDistance = function (profile, x1, x2) {
    const terrainProfile = fnNormalizeShadowTerrainProfile(profile, Math.min(x1, x2), Math.max(x1, x2))
    const points = terrainProfile.points
    const startX = Number(x1)
    const endX = Number(x2)
    if (!Number.isFinite(startX) || !Number.isFinite(endX)) return NaN
    if (Math.abs(endX - startX) < 1e-9) return 0
    const minX = Math.min(startX, endX)
    const maxX = Math.max(startX, endX)
    const samples = [{ x: minX, y: fnInterpolateShadowTerrainY(terrainProfile, minX) }]
    points.forEach(function (row) {
      if (!(row.x > minX && row.x < maxX)) return
      samples.push({ x: row.x, y: row.y })
    })
    samples.push({ x: maxX, y: fnInterpolateShadowTerrainY(terrainProfile, maxX) })
    samples.sort(function (a, b) { return a.x - b.x })
    let total = 0
    for (let i = 1; i < samples.length; i += 1) {
      const dx = Number(samples[i].x) - Number(samples[i - 1].x)
      const dy = Number(samples[i].y) - Number(samples[i - 1].y)
      total += Math.hypot(dx, dy)
    }
    return total
  }

  const fnFindShadowTerrainRayIntersection = function (profile, apexPoint, tanValue) {
    const terrainProfile = fnNormalizeShadowTerrainProfile(profile, Number(apexPoint && apexPoint.x) - 1, Number(apexPoint && apexPoint.x) + 1)
    const points = terrainProfile.points
    const apexX = Number(apexPoint && apexPoint.x)
    const apexY = Number(apexPoint && apexPoint.y)
    const tan = Number(tanValue)
    if (!Number.isFinite(apexX) || !Number.isFinite(apexY) || !Number.isFinite(tan) || points.length < 2) return null
    const fnRayY = function (x) {
      return apexY - ((x - apexX) * tan)
    }
    for (let i = 1; i < points.length; i += 1) {
      const p1 = points[i - 1]
      const p2 = points[i]
      const x1 = Number(p1.x)
      const x2 = Number(p2.x)
      if (!(x2 > apexX && x2 > x1)) continue
      const y1 = Number(p1.y)
      const y2 = Number(p2.y)
      const f1 = fnRayY(x1) - y1
      const f2 = fnRayY(x2) - y2
      if (Math.abs(f1) < 1e-9 && x1 >= apexX) return { x: x1, y: y1 }
      if (f1 * f2 > 0) continue
      const denom = f1 - f2
      const ratio = Math.abs(denom) > 1e-9 ? (f1 / denom) : 0
      const x = x1 + ((x2 - x1) * ratio)
      const y = y1 + ((y2 - y1) * ratio)
      if (x >= apexX) return { x: x, y: y }
    }
    return null
  }

  const fnBuildShadowModel = function ($modal) {
    const modeRaw = String($modal.find('[data-shadow-mode]').val() || '').trim()
    const demProviderKey = String($modal.find('[data-shadow-dem-provider]').val() || '').trim()
    const gimbalPitchRaw = Number(String($modal.find('[data-shadow-gimbal-pitch]').val() || '').trim())
    const rowSpacingRaw = Number(String($modal.find('[data-shadow-row-spacing]').val() || '').trim())
    const rowHeightRaw = Number(String($modal.find('[data-shadow-row-height]').val() || '').trim())
    const vfovRaw = Number(String($modal.find('[data-shadow-vfov]').val() || '').trim())
    const targetRowsRaw = Number(String($modal.find('[data-shadow-target-rows]').val() || '').trim())
    const gmRaw = Number(String($modal.find('[data-shadow-gm]').val() || '').trim())
    const droneCenterDistanceRaw = Number(String($modal.find('[data-shadow-drone-center-distance]').val() || '').trim())
    const mode = fnResolveShadowMode(modeRaw)
    const lastEdited = String($modal.attr('data-shadow-last-edited') || 'gm').trim().toLowerCase()
    const gimbalPitchDeg = Number.isFinite(gimbalPitchRaw) ? (gimbalPitchRaw <= 0 ? gimbalPitchRaw : -Math.abs(gimbalPitchRaw)) : SHADOW_DEFAULTS.gimbalPitchDeg
    const rowSpacingM = (Number.isFinite(rowSpacingRaw) && rowSpacingRaw > 0) ? rowSpacingRaw : SHADOW_DEFAULTS.rowSpacingM
    const rowHeightM = (Number.isFinite(rowHeightRaw) && rowHeightRaw > 0) ? rowHeightRaw : SHADOW_DEFAULTS.rowHeightM
    const vfovDeg = (Number.isFinite(vfovRaw) && vfovRaw > 0 && vfovRaw < 89.9) ? vfovRaw : SHADOW_DEFAULTS.vfovDeg
    const targetRows = fnClampShadowTargetRows(targetRowsRaw)
    const halfFov = vfovDeg / 2
    const absUpper = Math.abs(gimbalPitchDeg + halfFov)
    const absLower = Math.abs(gimbalPitchDeg - halfFov)
    if (!(absUpper > 0.001 && absUpper < 89.9 && absLower > 0.001 && absLower < 89.9)) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const tanUpper = Math.tan(absUpper * (Math.PI / 180))
    const tanLower = Math.tan(absLower * (Math.PI / 180))
    if (!(Math.abs(tanUpper) > 1e-8 && Math.abs(tanLower) > 1e-8)) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const cotUpper = 1 / tanUpper
    const cotLower = 1 / tanLower
    const spanFactor = cotUpper - cotLower
    if (!(spanFactor > 1e-8)) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const targetSpillM = rowHeightM * SHADOW_DEFAULTS.edgeMarginRatio
    const baseGroundSpanM = ((targetRows + 1) * rowSpacingM) + (2 * targetSpillM)
    const baseGm = baseGroundSpanM / spanFactor
    if (!Number.isFinite(baseGm) || !(baseGm > 0)) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const centerTan = Math.tan(Math.abs(gimbalPitchDeg) * (Math.PI / 180))
    if (!(Math.abs(centerTan) > 1e-8)) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const visibleRowCount = targetRows + 2
    const startX = -(((visibleRowCount - 1) * rowSpacingM) / 2)
    const searchHalfRange = Math.max(2 * rowSpacingM, (targetRows + 2) * rowSpacingM)
    const terrainHalfRange = searchHalfRange + baseGroundSpanM + (rowSpacingM * 2)
    const terrainFallbackXMin = -terrainHalfRange
    const terrainFallbackXMax = terrainHalfRange
    const demProfileRaw = ($modal && typeof $modal.data === 'function') ? ($modal.data('shadowDemProfile') || null) : null
    const demProfileBundle = (demProviderKey && demProfileRaw && demProfileRaw.providerKey === demProviderKey)
      ? demProfileRaw
      : null
    const mergedDemProfile = demProfileBundle && demProfileBundle.mergedProfile
      ? demProfileBundle.mergedProfile
      : null
    const primaryDemProfile = demProfileBundle && demProfileBundle.primaryProfile
      ? demProfileBundle.primaryProfile
      : null
    const fallbackDemProfile = demProfileBundle && demProfileBundle.fallbackProfile
      ? demProfileBundle.fallbackProfile
      : null
    const demProfile = mergedDemProfile
      ? fnNormalizeShadowTerrainProfile(mergedDemProfile, terrainFallbackXMin, terrainFallbackXMax)
      : fnBuildShadowFlatTerrainProfile(terrainFallbackXMin, terrainFallbackXMax)
    const fnTerrainY = function (x) {
      return fnInterpolateShadowTerrainY(demProfile, x)
    }

    const fnBuildGeometryForParams = function (gmValue, centerGroundX) {
      const droneX = centerGroundX - (gmValue / centerTan)
      const droneGroundY = fnTerrainY(droneX)
      const apexY = droneGroundY + gmValue
      const nearGroundIntersection = fnFindShadowTerrainRayIntersection(demProfile, { x: droneX, y: apexY }, tanLower)
      const farGroundIntersection = fnFindShadowTerrainRayIntersection(demProfile, { x: droneX, y: apexY }, tanUpper)
      if (!nearGroundIntersection || !farGroundIntersection) return null
      const rows = []
      for (let i = 0; i < visibleRowCount; i += 1) {
        const rowX = startX + (i * rowSpacingM)
        const baseY = fnTerrainY(rowX)
        const rowTopY = baseY + rowHeightM
        const yAtUpper = apexY - ((rowX - droneX) * tanUpper)
        const yAtLower = apexY - ((rowX - droneX) * tanLower)
        const visibleBottomY = Math.max(baseY, yAtLower)
        const visibleTopY = Math.min(rowTopY, yAtUpper)
        rows.push({
          index: i,
          x: rowX,
          baseY: baseY,
          topY: rowTopY,
          isTarget: i >= 1 && i <= targetRows,
          visibleBottomY: visibleBottomY,
          visibleTopY: visibleTopY,
          hasVisibleSegment: visibleTopY > visibleBottomY
        })
      }
      return {
        centerGroundX: centerGroundX,
        centerGroundY: fnTerrainY(centerGroundX),
        droneX: droneX,
        droneGroundY: droneGroundY,
        apexY: apexY,
        nearGroundIntersectionX: nearGroundIntersection.x,
        nearGroundIntersectionY: nearGroundIntersection.y,
        farGroundIntersectionX: farGroundIntersection.x,
        farGroundIntersectionY: farGroundIntersection.y,
        rows: rows
      }
    }

    const fnBuildProjectionForGeometry = function (geometry, gmValue) {
      const apex = { x: geometry.droneX, y: geometry.apexY }
      const blueCenterPoint = { x: geometry.centerGroundX, y: geometry.centerGroundY }
      const f1 = { x: geometry.nearGroundIntersectionX, y: geometry.nearGroundIntersectionY }
      const f2 = { x: geometry.farGroundIntersectionX, y: geometry.farGroundIntersectionY }
      const blueDx = blueCenterPoint.x - apex.x
      const blueDy = blueCenterPoint.y - apex.y
      const blueLen = Math.hypot(blueDx, blueDy)
      if (!(blueLen > 1e-9)) return null
      const photoDir = { x: -blueDy / blueLen, y: blueDx / blueLen }
      const fnCross = function (a, b) {
        return (a.x * b.y) - (a.y * b.x)
      }
      const fnProjectPoint = function (point) {
        const ray = { x: point.x - apex.x, y: point.y - apex.y }
        const denom = fnCross(ray, photoDir)
        if (Math.abs(denom) < 1e-9) return NaN
        const rel = { x: f1.x - apex.x, y: f1.y - apex.y }
        const t = fnCross(rel, photoDir) / denom
        if (!(t > 0)) return NaN
        const hit = {
          x: apex.x + (ray.x * t),
          y: apex.y + (ray.y * t)
        }
        return ((hit.x - f1.x) * photoDir.x) + ((hit.y - f1.y) * photoDir.y)
      }
      const uF1 = fnProjectPoint(f1)
      const uF2 = fnProjectPoint(f2)
      if (!Number.isFinite(uF1) || !Number.isFinite(uF2) || Math.abs(uF2 - uF1) < 1e-9) return null
      return {
        uMinFrame: Math.min(uF1, uF2),
        uMaxFrame: Math.max(uF1, uF2),
        projectPoint: fnProjectPoint
      }
    }

    const fnEvaluateCandidate = function (gmValue, centerGroundX) {
      if (!Number.isFinite(gmValue) || !(gmValue > 0)) return null
      const geometry = fnBuildGeometryForParams(gmValue, centerGroundX)
      const projection = fnBuildProjectionForGeometry(geometry, gmValue)
      if (!projection) return null
      const targetRowsData = geometry.rows.filter((row) => row.isTarget)
      if (!targetRowsData.length) return null
      const projected = []
      let fullCoverageLoss = 0
      for (let i = 0; i < targetRowsData.length; i += 1) {
        const row = targetRowsData[i]
        const uBottom = projection.projectPoint({ x: row.x, y: row.baseY })
        const uTop = projection.projectPoint({ x: row.x, y: row.topY })
        if (!Number.isFinite(uBottom) || !Number.isFinite(uTop)) return null
        projected.push(uBottom, uTop)
        fullCoverageLoss += Math.max(0, row.visibleBottomY - row.baseY)
        fullCoverageLoss += Math.max(0, row.topY - row.visibleTopY)
      }
      const uMinTarget = Math.min.apply(null, projected)
      const uMaxTarget = Math.max.apply(null, projected)
      const marginBottom = uMinTarget - projection.uMinFrame
      const marginTop = projection.uMaxFrame - uMaxTarget
      const centerError = marginBottom - marginTop
      const penalty = Math.max(0, -marginBottom) + Math.max(0, -marginTop)
      const bottomEdgeRow = geometry.rows[0]
      const topEdgeRow = geometry.rows[geometry.rows.length - 1]
      const spillBottomM = Math.max(0, Number(bottomEdgeRow.visibleTopY) - Number(bottomEdgeRow.visibleBottomY))
      const spillTopM = Math.max(0, Number(topEdgeRow.visibleTopY) - Number(topEdgeRow.visibleBottomY))
      const spillErrorBottom = Math.abs(spillBottomM - targetSpillM)
      const spillErrorTop = Math.abs(spillTopM - targetSpillM)
      const spillAsymmetry = Math.abs(spillBottomM - spillTopM)
      const score = (
        spillErrorBottom +
        spillErrorTop +
        (spillAsymmetry * 0.8) +
        (Math.abs(centerError) * 0.6) +
        (penalty * 200) +
        (fullCoverageLoss * 500)
      )
      return {
        score: score,
        centerError: centerError,
        marginBottom: marginBottom,
        marginTop: marginTop,
        geometry: geometry,
        gm: gmValue,
        spillBottomM: spillBottomM,
        spillTopM: spillTopM
      }
    }

    const manualGmFromInput = (Number.isFinite(gmRaw) && gmRaw > 0) ? gmRaw : NaN
    const manualDoFromInput = (Number.isFinite(droneCenterDistanceRaw) && droneCenterDistanceRaw > 0) ? droneCenterDistanceRaw : NaN
    let manualGm = NaN
    if (mode === 'manual') {
      if (lastEdited === 'do' && Number.isFinite(manualDoFromInput)) {
        manualGm = manualDoFromInput * centerTan
      } else if (Number.isFinite(manualGmFromInput)) {
        manualGm = manualGmFromInput
      } else if (Number.isFinite(manualDoFromInput)) {
        manualGm = manualDoFromInput * centerTan
      } else {
        manualGm = baseGm
      }
      if (!Number.isFinite(manualGm) || !(manualGm > 0)) {
        manualGm = baseGm
      }
    }

    let bestEval = null

    if (mode === 'manual') {
      const xSampleCount = 220
      for (let xIdx = 0; xIdx <= xSampleCount; xIdx += 1) {
        const xRatio = xIdx / xSampleCount
        const centerGroundX = (-searchHalfRange) + (2 * searchHalfRange * xRatio)
        const current = fnEvaluateCandidate(manualGm, centerGroundX)
        if (!current) continue
        if (!bestEval || current.score < bestEval.score) {
          bestEval = current
        }
      }
      if (bestEval) {
        const refineXRange = Math.max(0.6, rowSpacingM * 1.3)
        const refineXMin = bestEval.geometry.centerGroundX - refineXRange
        const refineXMax = bestEval.geometry.centerGroundX + refineXRange
        const refineXCount = 150
        for (let xIdx = 0; xIdx <= refineXCount; xIdx += 1) {
          const xRatio = xIdx / refineXCount
          const centerGroundX = refineXMin + ((refineXMax - refineXMin) * xRatio)
          const current = fnEvaluateCandidate(manualGm, centerGroundX)
          if (!current) continue
          if (!bestEval || current.score < bestEval.score) {
            bestEval = current
          }
        }
      }
    } else {
      const gmMin = Math.max(rowHeightM * 1.2, baseGm * 0.55)
      const gmMax = Math.max(gmMin + 1, baseGm * 1.65)
      const gmSampleCount = 42
      const xSampleCount = 110
      for (let gmIdx = 0; gmIdx <= gmSampleCount; gmIdx += 1) {
        const gmRatio = gmIdx / gmSampleCount
        const gmCandidate = gmMin + ((gmMax - gmMin) * gmRatio)
        for (let xIdx = 0; xIdx <= xSampleCount; xIdx += 1) {
          const xRatio = xIdx / xSampleCount
          const centerGroundX = (-searchHalfRange) + (2 * searchHalfRange * xRatio)
          const current = fnEvaluateCandidate(gmCandidate, centerGroundX)
          if (!current) continue
          if (!bestEval || current.score < bestEval.score) {
            bestEval = current
          }
        }
      }
    }
    if (bestEval && mode !== 'manual') {
      const refineGmRange = Math.max(1.2, baseGm * 0.14)
      const refineXRange = Math.max(0.6, rowSpacingM * 1.3)
      const refineGmMin = Math.max(rowHeightM * 1.05, bestEval.gm - refineGmRange)
      const refineGmMax = Math.max(refineGmMin + 0.4, bestEval.gm + refineGmRange)
      const refineXMin = bestEval.geometry.centerGroundX - refineXRange
      const refineXMax = bestEval.geometry.centerGroundX + refineXRange
      const refineGmCount = 28
      const refineXCount = 72
      for (let gmIdx = 0; gmIdx <= refineGmCount; gmIdx += 1) {
        const gmRatio = gmIdx / refineGmCount
        const gmCandidate = refineGmMin + ((refineGmMax - refineGmMin) * gmRatio)
        for (let xIdx = 0; xIdx <= refineXCount; xIdx += 1) {
          const xRatio = xIdx / refineXCount
          const centerGroundX = refineXMin + ((refineXMax - refineXMin) * xRatio)
          const current = fnEvaluateCandidate(gmCandidate, centerGroundX)
          if (!current) continue
          if (!bestEval || current.score < bestEval.score) {
            bestEval = current
          }
        }
      }
    }
    if (!bestEval || !bestEval.geometry) {
      return { valid: false, demProviderKey: demProviderKey, gimbalPitchDeg: gimbalPitchDeg, rowSpacingM: rowSpacingM, rowHeightM: rowHeightM, vfovDeg: vfovDeg, targetRows: targetRows }
    }
    const gm = bestEval.gm
    const centerGroundX = bestEval.geometry.centerGroundX
    const droneX = bestEval.geometry.droneX
    const centerGroundY = bestEval.geometry.centerGroundY
    const droneGroundY = bestEval.geometry.droneGroundY
    const nearGroundIntersectionX = bestEval.geometry.nearGroundIntersectionX
    const nearGroundIntersectionY = bestEval.geometry.nearGroundIntersectionY
    const farGroundIntersectionX = bestEval.geometry.farGroundIntersectionX
    const farGroundIntersectionY = bestEval.geometry.farGroundIntersectionY
    const groundSpanM = fnMeasureShadowTerrainDistance(demProfile, nearGroundIntersectionX, farGroundIntersectionX)
    const rows = bestEval.geometry.rows
    const droneToCenterGroundM = fnMeasureShadowTerrainDistance(demProfile, droneX, centerGroundX)
    return {
      valid: true,
      mode: mode,
      demProviderKey: demProviderKey,
      demFallbackProviderKey: demProfileBundle ? String(demProfileBundle.fallbackProviderKey || '').trim() : '',
      demProfileSignature: demProfileBundle ? String(demProfileBundle.signature || '').trim() : '',
      demProfileApplied: !!mergedDemProfile,
      primaryDemProfile: primaryDemProfile,
      fallbackDemProfile: fallbackDemProfile,
      fallbackDemProfileApplied: !!fallbackDemProfile,
      gimbalPitchDeg: gimbalPitchDeg,
      rowSpacingM: rowSpacingM,
      rowHeightM: rowHeightM,
      vfovDeg: vfovDeg,
      targetRows: targetRows,
      gm: gm,
      edgeMarginM: targetSpillM,
      groundSpanM: groundSpanM,
      nearGroundIntersectionM: nearGroundIntersectionX,
      nearGroundIntersectionY: nearGroundIntersectionY,
      farGroundIntersectionM: farGroundIntersectionX,
      farGroundIntersectionY: farGroundIntersectionY,
      centerGroundX: centerGroundX,
      centerGroundY: centerGroundY,
      droneX: droneX,
      droneGroundY: droneGroundY,
      droneToCenterGroundM: droneToCenterGroundM,
      visibleRowCount: visibleRowCount,
      terrainProfile: demProfile,
      rows: rows,
      centeringError: bestEval.centerError,
      spillBottomM: bestEval.spillBottomM,
      spillTopM: bestEval.spillTopM
    }
  }

  const fnRenderShadowPreview = function ($modal) {
    const canvas = $modal.find('[data-shadow-preview-canvas]').get(0)
    if (!canvas || typeof canvas.getContext !== 'function') return null
    const ctx2d = canvas.getContext('2d')
    if (!ctx2d) return null
    const model = fnBuildShadowModel($modal)
    const w = canvas.width
    const h = canvas.height
    ctx2d.clearRect(0, 0, w, h)
    ctx2d.fillStyle = '#f8f9fa'
    ctx2d.fillRect(0, 0, w, h)
    if (!model.valid) return model

    const rowXValues = Array.isArray(model.rows) ? model.rows.map((row) => Number(row && row.x)).filter((n) => Number.isFinite(n)) : []
    const rowXMin = rowXValues.length ? Math.min.apply(null, rowXValues) : Math.min(model.centerGroundX, 0)
    const rowXMax = rowXValues.length ? Math.max.apply(null, rowXValues) : Math.max(model.centerGroundX, 0)
    const terrainPoints = Array.isArray(model.terrainProfile && model.terrainProfile.points) ? model.terrainProfile.points : []
    const relevantXValues = [
      model.droneX,
      model.nearGroundIntersectionM,
      model.centerGroundX,
      model.farGroundIntersectionM,
      rowXMin,
      rowXMax
    ].filter(function (n) { return Number.isFinite(n) })
    const rawContentXMin = relevantXValues.length ? Math.min.apply(null, relevantXValues) : 0
    const rawContentXMax = relevantXValues.length ? Math.max.apply(null, relevantXValues) : 1
    const cropPadX = Math.max(0.18, Math.min(Math.max(model.rowSpacingM * 0.32, (rawContentXMax - rawContentXMin) * 0.05), 1.25))
    const cropXMin = rawContentXMin - cropPadX
    const cropXMax = rawContentXMax + cropPadX
    const terrainPointsInCrop = terrainPoints.filter(function (row) {
      const x = Number(row && row.x)
      return Number.isFinite(x) && x >= cropXMin && x <= cropXMax
    })
    const terrainYValuesInCrop = terrainPointsInCrop.map(function (row) { return Number(row && row.y) }).filter(function (n) { return Number.isFinite(n) })
    const rowBaseYValues = Array.isArray(model.rows) ? model.rows.map(function (row) { return Number(row && row.baseY) }).filter(function (n) { return Number.isFinite(n) }) : []
    const rowTopYValues = Array.isArray(model.rows) ? model.rows.map(function (row) { return Number(row && row.topY) }).filter(function (n) { return Number.isFinite(n) }) : []
    const rowVisibleYValues = Array.isArray(model.rows) ? model.rows.reduce(function (acc, row) {
      if (Number.isFinite(Number(row && row.visibleBottomY))) acc.push(Number(row.visibleBottomY))
      if (Number.isFinite(Number(row && row.visibleTopY))) acc.push(Number(row.visibleTopY))
      return acc
    }, []) : []
    const relevantYValues = []
      .concat(terrainYValuesInCrop)
      .concat(rowBaseYValues)
      .concat(rowTopYValues)
      .concat(rowVisibleYValues)
      .concat([
        model.nearGroundIntersectionY,
        model.centerGroundY,
        model.farGroundIntersectionY,
        model.droneGroundY,
        (model.droneGroundY || 0) + model.gm
      ])
      .filter(function (n) { return Number.isFinite(n) })
    const rawContentYMin = relevantYValues.length ? Math.min.apply(null, relevantYValues) : 0
    const rawContentYMax = relevantYValues.length ? Math.max.apply(null, relevantYValues) : 1
    const cropPadY = Math.max(0.2, Math.min(Math.max(model.rowHeightM * 0.18, (rawContentYMax - rawContentYMin) * 0.06), 1.2))
    const xMin = cropXMin
    const xMax = cropXMax
    const yMin = rawContentYMin - cropPadY
    const yMax = rawContentYMax + cropPadY
    const padLeft = 26
    const padRight = 12
    const padTop = 10
    const padBottom = 24
    const drawW = Math.max(20, w - padLeft - padRight)
    const drawH = Math.max(20, h - padTop - padBottom)
    const xSpan = Math.max(1e-9, xMax - xMin)
    const ySpan = Math.max(1e-9, yMax - yMin)
    const scale = Math.min(drawW / xSpan, drawH / ySpan)
    const usedW = xSpan * scale
    const usedH = ySpan * scale
    const offsetX = padLeft + ((drawW - usedW) / 2)
    const offsetY = padTop + ((drawH - usedH) / 2)
    const fnX = function (value) {
      return offsetX + ((value - xMin) * scale)
    }
    const fnY = function (value) {
      return offsetY + ((yMax - value) * scale)
    }

    const fnTerrainCanvasY = function (x) {
      return fnY(fnInterpolateShadowTerrainY(model.terrainProfile, x))
    }
    const apexX = fnX(model.droneX)
    const apexY = fnY((model.droneGroundY || 0) + model.gm)
    const nearX = fnX(model.nearGroundIntersectionM)
    const nearY = fnY(model.nearGroundIntersectionY || 0)
    const farX = fnX(model.farGroundIntersectionM)
    const farY = fnY(model.farGroundIntersectionY || 0)
    const centerX = fnX(model.centerGroundX)
    const centerY = fnY(model.centerGroundY || 0)

    const fnDrawTerrainProfile = function (profile, color, lineWidth, opts) {
      const normalizedProfile = fnTryNormalizeShadowTerrainProfile(profile)
      if (!normalizedProfile) return false
      const profileSamples = Array.isArray(normalizedProfile.samples) ? normalizedProfile.samples : []
      const trimGapEdges = !!(opts && opts.trimGapEdges)
      const validSegments = []
      let currentSegment = []
      let currentStartIdx = -1
      profileSamples.forEach(function (row, sampleIdx) {
        const x = Number(row && row.x)
        const y = fnToFiniteShadowElevationOrNull(row && row.y)
        if (!Number.isFinite(x) || y === null) {
          if (currentSegment.length) {
            validSegments.push({
              points: currentSegment,
              startIdx: currentStartIdx,
              endIdx: sampleIdx - 1
            })
            currentSegment = []
            currentStartIdx = -1
          }
          return
        }
        if (!currentSegment.length) currentStartIdx = sampleIdx
        currentSegment.push({
          x: x,
          y: y
        })
      })
      if (currentSegment.length) {
        validSegments.push({
          points: currentSegment,
          startIdx: currentStartIdx,
          endIdx: profileSamples.length - 1
        })
      }
      let hasStroke = false
      ctx2d.strokeStyle = color
      ctx2d.lineWidth = lineWidth
      validSegments.forEach(function (segmentMeta) {
        let drawableSegment = segmentMeta.points.slice()
        if (trimGapEdges) {
          const hasGapBefore = segmentMeta.startIdx > 0 && fnToFiniteShadowElevationOrNull(profileSamples[segmentMeta.startIdx - 1] && profileSamples[segmentMeta.startIdx - 1].y) === null
          const hasGapAfter = segmentMeta.endIdx < (profileSamples.length - 1) && fnToFiniteShadowElevationOrNull(profileSamples[segmentMeta.endIdx + 1] && profileSamples[segmentMeta.endIdx + 1].y) === null
          if (hasGapBefore && drawableSegment.length > 1) drawableSegment = drawableSegment.slice(1)
          if (hasGapAfter && drawableSegment.length > 1) drawableSegment = drawableSegment.slice(0, -1)
        }
        if (drawableSegment.length < 2) return
        ctx2d.beginPath()
        drawableSegment.forEach(function (row, idx) {
          const px = fnX(row.x)
          const py = fnY(row.y)
          if (idx === 0) {
            ctx2d.moveTo(px, py)
          } else {
            ctx2d.lineTo(px, py)
          }
        })
        ctx2d.stroke()
        if (!hasStroke) {
          hasStroke = true
        }
      })
      return hasStroke
    }

    const hasCombinedTerrainProfile = model.demProfileApplied
      ? fnDrawTerrainProfile(model.terrainProfile, 'rgba(73, 80, 87, 0.55)', 1.25)
      : false
    const hasPrimaryTerrainProfile = fnDrawTerrainProfile(model.primaryDemProfile, '#8b5e34', 2, { trimGapEdges: true })
    const hasFallbackTerrainProfile = fnDrawTerrainProfile(model.fallbackDemProfile, '#dc3545', 2)
    if (!hasCombinedTerrainProfile && !hasPrimaryTerrainProfile && !hasFallbackTerrainProfile) {
      ctx2d.strokeStyle = model.demProfileApplied ? '#8b5e34' : '#495057'
      ctx2d.lineWidth = model.demProfileApplied ? 2 : 1
      ctx2d.beginPath()
      terrainPoints.forEach(function (row, idx) {
        const px = fnX(row.x)
        const py = fnY(row.y)
        if (idx === 0) {
          ctx2d.moveTo(px, py)
        } else {
          ctx2d.lineTo(px, py)
        }
      })
      ctx2d.stroke()
    }
    if (fnIsShadowDemDeepDebugEnabled()) {
      const renderDebugSignature = String(model && model.demProfileSignature || '').trim()
      const lastRenderDebugSignature = (typeof window !== 'undefined')
        ? String(window.PORTAL_SHADOW_DEM_RENDER_DEBUG_SIGNATURE || '').trim()
        : ''
      if (!renderDebugSignature || renderDebugSignature !== lastRenderDebugSignature) {
        if (typeof window !== 'undefined') {
          window.PORTAL_SHADOW_DEM_RENDER_DEBUG_SIGNATURE = renderDebugSignature
        }
        fnLogShadowDemDebug('log', '[shadow-dem] render profile', {
          signature: renderDebugSignature,
          hasCombinedTerrainProfile: !!hasCombinedTerrainProfile,
          hasPrimaryTerrainProfile: !!hasPrimaryTerrainProfile,
          hasFallbackTerrainProfile: !!hasFallbackTerrainProfile,
          combined: fnBuildShadowDemProfileDebugSummary(model.terrainProfile),
          primary: fnBuildShadowDemProfileDebugSummary(model.primaryDemProfile),
          fallback: fnBuildShadowDemProfileDebugSummary(model.fallbackDemProfile),
          rowAnchors: Array.isArray(model.rows)
            ? model.rows.slice(0, 5).map(function (row) {
              return {
                rowLabel: row && Number.isFinite(Number(row.index)) ? String.fromCharCode(65 + Number(row.index)) : '',
                x: fnRoundShadowDebugNumber(row && row.x, 3),
                baseY: fnRoundShadowDebugNumber(row && row.baseY, 3),
                topY: fnRoundShadowDebugNumber(row && row.topY, 3),
                visibleBottomY: fnRoundShadowDebugNumber(row && row.visibleBottomY, 3),
                visibleTopY: fnRoundShadowDebugNumber(row && row.visibleTopY, 3)
              }
            })
            : []
        })
      }
    }

    ctx2d.fillStyle = 'rgba(13, 110, 253, 0.14)'
    ctx2d.strokeStyle = 'rgba(13, 110, 253, 0.75)'
    ctx2d.lineWidth = 2
    ctx2d.beginPath()
    ctx2d.moveTo(apexX, apexY)
    ctx2d.lineTo(nearX, nearY)
    ctx2d.lineTo(farX, farY)
    ctx2d.closePath()
    ctx2d.fill()
    ctx2d.stroke()

    ctx2d.setLineDash([6, 4])
    ctx2d.beginPath()
    ctx2d.moveTo(apexX, apexY)
    ctx2d.lineTo(centerX, centerY)
    ctx2d.stroke()
    ctx2d.setLineDash([])

    ctx2d.setLineDash([4, 4])
    ctx2d.strokeStyle = '#dc3545'
    ctx2d.lineWidth = 1.5
    ctx2d.beginPath()
    ctx2d.moveTo(apexX, apexY)
    ctx2d.lineTo(apexX, fnY(model.droneGroundY || 0))
    ctx2d.stroke()
    ctx2d.setLineDash([])

    model.rows.forEach((row) => {
      const rowX = fnX(row.x)
      const rowTopY = fnY(row.topY)
      const rowBottomY = fnY(row.baseY)
      ctx2d.strokeStyle = row.isTarget ? '#198754' : '#6c757d'
      ctx2d.lineWidth = row.isTarget ? 3 : 2
      ctx2d.beginPath()
      ctx2d.moveTo(rowX, rowBottomY)
      ctx2d.lineTo(rowX, rowTopY)
      ctx2d.stroke()
      if (row.hasVisibleSegment) {
        ctx2d.strokeStyle = row.isTarget ? '#0d6efd' : '#20c997'
        ctx2d.lineWidth = row.isTarget ? 5 : 4
        ctx2d.beginPath()
        ctx2d.moveTo(rowX, fnY(row.visibleBottomY))
        ctx2d.lineTo(rowX, fnY(row.visibleTopY))
        ctx2d.stroke()
      }
      const rowLabel = row.index < 26 ? String.fromCharCode(65 + row.index) : ('R' + (row.index + 1))
      ctx2d.fillStyle = '#212529'
      ctx2d.font = '12px sans-serif'
      ctx2d.fillText(rowLabel, rowX - 4, Math.max(12, rowTopY - 6))
    })

    const fnDrawXAxisMarker = function (x, label) {
      if (!Number.isFinite(x)) return
      const px = fnX(x)
      const baseY = fnTerrainCanvasY(x)
      const tickTopY = baseY + 1
      const tickBottomY = Math.min(h - 8, baseY + 8)
      const labelY = Math.min(h - 2, baseY + 20)
      ctx2d.strokeStyle = '#495057'
      ctx2d.lineWidth = 1
      ctx2d.beginPath()
      ctx2d.moveTo(px, tickTopY)
      ctx2d.lineTo(px, tickBottomY)
      ctx2d.stroke()
      ctx2d.fillStyle = '#343a40'
      ctx2d.font = '12px sans-serif'
      ctx2d.textAlign = 'center'
      ctx2d.fillText(String(label || ''), px, labelY)
      ctx2d.textAlign = 'start'
    }
    fnDrawXAxisMarker(model.nearGroundIntersectionM, 'F1')
    fnDrawXAxisMarker(model.centerGroundX, 'O')
    fnDrawXAxisMarker(model.farGroundIntersectionM, 'F2')
    fnDrawXAxisMarker(model.droneX, 'D')
    const centerGroundXForPhotoLine = Number.isFinite(model.centerGroundX) ? model.centerGroundX : 0
    const apexPxX = fnX(model.droneX)
    const apexPxY = fnY((model.droneGroundY || 0) + model.gm)
    const bluePxDx = fnX(centerGroundXForPhotoLine) - apexPxX
    const bluePxDy = fnY(model.centerGroundY || 0) - apexPxY
    const bluePxLen = Math.hypot(bluePxDx, bluePxDy)
    if (bluePxLen > 1e-9) {
      const perpPxUx = -bluePxDy / bluePxLen
      const perpPxUy = bluePxDx / bluePxLen
      const photoLineHalfLenPx = Math.max(w, h) * 1.6
      const f1PxX = fnX(model.nearGroundIntersectionM)
      const f1PxY = fnY(model.nearGroundIntersectionY || 0)
      const p1PxX = f1PxX - (perpPxUx * photoLineHalfLenPx)
      const p1PxY = f1PxY - (perpPxUy * photoLineHalfLenPx)
      const p2PxX = f1PxX + (perpPxUx * photoLineHalfLenPx)
      const p2PxY = f1PxY + (perpPxUy * photoLineHalfLenPx)
      ctx2d.setLineDash([5, 4])
      ctx2d.strokeStyle = '#6c757d'
      ctx2d.lineWidth = 1.5
      ctx2d.beginPath()
      ctx2d.moveTo(p1PxX, p1PxY)
      ctx2d.lineTo(p2PxX, p2PxY)
      ctx2d.stroke()
      ctx2d.setLineDash([])
    }

    ctx2d.fillStyle = '#dc3545'
    ctx2d.strokeStyle = '#dc3545'
    ctx2d.lineWidth = 2
    ctx2d.beginPath()
    ctx2d.arc(apexX, apexY, 5, 0, Math.PI * 2)
    ctx2d.fill()
    ctx2d.beginPath()
    ctx2d.moveTo(apexX - 8, apexY)
    ctx2d.lineTo(apexX + 8, apexY)
    ctx2d.moveTo(apexX, apexY - 8)
    ctx2d.lineTo(apexX, apexY + 8)
    ctx2d.stroke()
    return model
  }

  const fnRenderShadowPhotoPreview = function ($modal, model) {
    const canvas = $modal.find('[data-shadow-photo-canvas]').get(0)
    if (!canvas || typeof canvas.getContext !== 'function') return
    const ctx2d = canvas.getContext('2d')
    if (!ctx2d) return
    const computed = (model && typeof model === 'object') ? model : fnBuildShadowModel($modal)
    const w = canvas.width
    const h = canvas.height
    ctx2d.clearRect(0, 0, w, h)
    ctx2d.fillStyle = '#ffffff'
    ctx2d.fillRect(0, 0, w, h)
    if (!computed || !computed.valid || !Array.isArray(computed.rows) || !computed.rows.length) return

    const rowsDesc = computed.rows.slice().sort((a, b) => b.index - a.index)
    const stemCount = 8
    const stemsX = []
    for (let i = 0; i < stemCount; i += 1) {
      const ratio = stemCount <= 1 ? 0.5 : (i / (stemCount - 1))
      stemsX.push(ratio * Math.max(1, w - 1))
    }
    const stemWidthPx = 4
    const apex = { x: computed.droneX, y: (computed.droneGroundY || 0) + computed.gm }
    const centerGroundXForPhotoLine = Number.isFinite(computed.centerGroundX) ? computed.centerGroundX : 0
    const blueCenterPoint = { x: centerGroundXForPhotoLine, y: computed.centerGroundY || 0 }
    const f1 = { x: computed.nearGroundIntersectionM, y: computed.nearGroundIntersectionY || 0 }
    const f2 = { x: computed.farGroundIntersectionM, y: computed.farGroundIntersectionY || 0 }
    const blueDx = blueCenterPoint.x - apex.x
    const blueDy = blueCenterPoint.y - apex.y
    const blueLen = Math.hypot(blueDx, blueDy)
    if (!(blueLen > 1e-9)) return
    const photoDir = { x: -blueDy / blueLen, y: blueDx / blueLen }
    const fnCross = function (a, b) {
      return (a.x * b.y) - (a.y * b.x)
    }
    const fnProjectPointToPhotoLine = function (point) {
      const ray = { x: point.x - apex.x, y: point.y - apex.y }
      const denom = fnCross(ray, photoDir)
      if (Math.abs(denom) < 1e-9) return NaN
      const rel = { x: f1.x - apex.x, y: f1.y - apex.y }
      const t = fnCross(rel, photoDir) / denom
      if (!(t > 0)) return NaN
      const hit = {
        x: apex.x + (ray.x * t),
        y: apex.y + (ray.y * t)
      }
      return ((hit.x - f1.x) * photoDir.x) + ((hit.y - f1.y) * photoDir.y)
    }
    const uF1 = fnProjectPointToPhotoLine(f1)
    const uF2 = fnProjectPointToPhotoLine(f2)
    if (!Number.isFinite(uF1) || !Number.isFinite(uF2) || Math.abs(uF2 - uF1) < 1e-9) return
    const fnProjectToCanvasY = function (u) {
      if (!Number.isFinite(u)) return NaN
      const ratio = (u - uF1) / (uF2 - uF1)
      return h - (ratio * h)
    }

    rowsDesc.forEach((row) => {
      const rowX = Number(row && row.x)
      const visibleBottom = Number(row && row.visibleBottomY)
      const visibleTop = Number(row && row.visibleTopY)
      if (!Number.isFinite(rowX) || !Number.isFinite(visibleBottom) || !Number.isFinite(visibleTop) || !(visibleTop > visibleBottom)) return
      const uBottom = fnProjectPointToPhotoLine({ x: rowX, y: visibleBottom })
      const uTop = fnProjectPointToPhotoLine({ x: rowX, y: visibleTop })
      const yBottom = fnProjectToCanvasY(uBottom)
      const yTop = fnProjectToCanvasY(uTop)
      if (!Number.isFinite(yBottom) || !Number.isFinite(yTop)) return

      stemsX.forEach((stemX) => {
        const y1 = Math.max(0, Math.min(h, yBottom))
        const y2 = Math.max(0, Math.min(h, yTop))
        const rectY = Math.min(y1, y2)
        const rectH = Math.abs(y2 - y1)
        if (!(rectH > 0)) return
        const x = stemX - (stemWidthPx / 2)
        const strokeColor = row.isTarget ? '#0d6efd' : '#20c997'
        const fillColor = row.isTarget ? 'rgba(13, 110, 253, 0.5)' : 'rgba(32, 201, 151, 0.5)'
        ctx2d.fillStyle = fillColor
        ctx2d.strokeStyle = strokeColor
        ctx2d.lineWidth = 1
        ctx2d.fillRect(x, rectY, stemWidthPx, rectH)
        ctx2d.strokeRect(x, rectY, stemWidthPx, rectH)
      })
    })
  }

  const fnRenderShadowCalculations = function ($modal, axisUpBearing, model) {
    if (!$modal || !$modal.length) return
    const computed = model || fnBuildShadowModel($modal)
    const fnFmt = function (value, digits) {
      if (!Number.isFinite(Number(value))) return '-'
      return Number(value).toFixed(digits)
    }
    $modal.find('[data-shadow-calc-axis-up-bearing]').text(fnFmt(axisUpBearing, 2))
    $modal.find('[data-shadow-calc-drone-center-row-distance]').text(computed.valid ? fnFmt(computed.droneToCenterGroundM, 3) : '-')
    $modal.find('[data-shadow-calc-near-ground-intersection]').text(
      computed.valid ? fnFmt(Math.abs(Number(computed.centerGroundX) - Number(computed.nearGroundIntersectionM)), 3) : '-'
    )
    $modal.find('[data-shadow-calc-far-ground-intersection]').text(
      computed.valid ? fnFmt(Math.abs(Number(computed.farGroundIntersectionM) - Number(computed.centerGroundX)), 3) : '-'
    )
    $modal.find('[data-shadow-calc-ground-span]').text(computed.valid ? fnFmt(computed.groundSpanM, 3) : '-')
    if (computed.valid) {
      $modal.find('[data-shadow-gm]').val(fnFmt(computed.gm, 1))
      $modal.find('[data-shadow-drone-center-distance]').val(fnFmt(computed.droneToCenterGroundM, 1))
    } else {
      $modal.find('[data-shadow-gm]').val('')
      $modal.find('[data-shadow-drone-center-distance]').val('')
    }
  }

  $body.find('[data-leaf-shadow]')
    .off('click.portalShadow')
    .on('click.portalShadow', function () {
      const missionState = fnGetMissionState()
      if (!missionState || !Array.isArray(missionState.waypoints) || !missionState.waypoints.length) {
        Swal.fire(fnT('seek.no_movable_point'))
        return
      }
      const map = fnGetMap()
      if (!map) return
      if (fnGetSeekDrawActive()) return

      const fnStartManualAxisDraw = function (onAxisReady) {
        if (fnGetSeekDrawActive()) return
        Swal.fire({
          toast: true,
          position: 'bottom',
          customClass: { popup: 'swal-toast-bottom-center' },
          icon: 'info',
          title: fnT('seek.redraw_axis_title'),
          timer: 1800,
          timerProgressBar: true,
          showConfirmButton: false
        })
        fnSetSeekMode(true)
        fnSetSeekDrawActive(true)
        fnSetSeekAxisCallback(function (axisLayer) {
          decorateLeafletPathDualDash(axisLayer, { L: L })
          const latlngs = axisLayer && axisLayer.getLatLngs ? axisLayer.getLatLngs() : []
          if (!latlngs || latlngs.length < 2) {
            Swal.fire(fnT('seek.axis_need_two_points'))
            return
          }
          if (typeof onAxisReady === 'function') onAxisReady(axisLayer)
        })
        map.once('draw:drawstop', function () {
          setTimeout(function () {
            if (!fnGetSeekDrawActive()) return
            fnSetSeekMode(false)
            fnSetSeekDrawActive(false)
            fnSetSeekDrawLine(null)
            fnSetSeekAxisCallback(null)
          }, 0)
        })
        const drawLine = new L.Draw.Polyline(map, {
          shapeOptions: { color: '#0d6efd', weight: 3, dashArray: '6,6' },
          maxPoints: 2,
          repeatMode: false
        })
        fnSetSeekDrawLine(drawLine)
        drawLine.enable()
        installLeafletDrawDualDashPreview({
          L: L,
          map: map,
          drawLayer: drawLine
        })
      }

      const fnOpenShadowPopup = function (axisLayer) {
        if (!axisLayer) return
        let axisUpBearing = fnResolveSeekAxisUpBearing(axisLayer)
        if (!Number.isFinite(axisUpBearing)) {
          Swal.fire(fnT('shadow.invalid_axis'))
          return
        }
        axisUpBearing = normalizeBearingDeg(axisUpBearing)
        const drawnItems = fnGetDrawnItems()
        if (drawnItems) {
          drawnItems.addLayer(axisLayer)
          drawnItems.addTo(map)
        }
        const fnCleanup = function () {
          if (!drawnItems || !axisLayer) return
          if (drawnItems.hasLayer(axisLayer)) drawnItems.removeLayer(axisLayer)
        }
        const tpl = $('[data-tpl-shadow-popup]').html() || ''
        const footerTpl = $('[data-tpl-shadow-extra-actions]').html() || ''
        areaSwal.fire({
          title: fnT('shadow.title'),
          width: 1080,
          position: 'bottom-right',
          backdrop: false,
          showConfirmButton: false,
          showDenyButton: false,
          showCancelButton: false,
          footer: ' ',
          customClass: { popup: 'swal-seek-bottom-panel' },
          html: tpl,
          didOpen: function (modal) {
            const $modal = $(modal)
            const footerEl = modal && modal.querySelector ? modal.querySelector('.swal2-actions.modal-footer') : null
            if (footerEl) {
              footerEl.innerHTML = footerTpl
            }
            let rowSpacingEdited = false

            const fnReadPositiveNumber = function ($el) {
              const value = Number(String($el.val() || '').trim())
              return (Number.isFinite(value) && value > 0) ? value : NaN
            }
            const fnIsShadowManualMode = function () {
              const mode = fnResolveShadowMode($modal.find('[data-shadow-mode]').val())
              return mode === 'manual'
            }
            const fnSyncShadowGmAndDistance = function (source) {
              const gsz = Number(String($modal.find('[data-shadow-gimbal-pitch]').val() || '').trim())
              const normalizedGsz = Number.isFinite(gsz) ? (gsz <= 0 ? gsz : -Math.abs(gsz)) : SHADOW_DEFAULTS.gimbalPitchDeg
              const centerTan = Math.tan(Math.abs(normalizedGsz) * (Math.PI / 180))
              if (!(Math.abs(centerTan) > 1e-8)) return
              if (source === 'do') {
                const doM = fnReadPositiveNumber($modal.find('[data-shadow-drone-center-distance]'))
                if (!Number.isFinite(doM)) return
                const gm = doM * centerTan
                if (Number.isFinite(gm) && gm > 0) $modal.find('[data-shadow-gm]').val(gm.toFixed(1))
                $modal.attr('data-shadow-last-edited', 'do')
                return
              }
              const gm = fnReadPositiveNumber($modal.find('[data-shadow-gm]'))
              if (!Number.isFinite(gm)) return
              const doM = gm / centerTan
              if (Number.isFinite(doM) && doM > 0) $modal.find('[data-shadow-drone-center-distance]').val(doM.toFixed(1))
              $modal.attr('data-shadow-last-edited', 'gm')
            }

            const fnSubmitShadowCreate = function (includeLeft, includeRight) {
              const model = fnBuildShadowModel($modal)
              if (!model.valid || !Number.isFinite(model.gm) || !(model.gm > 0)) {
                Swal.showValidationMessage(fnT('shadow.invalid_gm'))
                return
              }
              if (!Number.isFinite(model.gimbalPitchDeg) || Math.abs(model.gimbalPitchDeg) < 0.001) {
                Swal.showValidationMessage(fnT('shadow.invalid_pitch'))
                return
              }
              fnEmitShadowCreateRequest({
                axisUpBearing: axisUpBearing,
                demProvider: model.demProviderKey || '',
                leftPitch: model.gimbalPitchDeg,
                rightPitch: model.gimbalPitchDeg,
                projectHeight: model.gm,
                rowSpacing: model.rowSpacingM,
                rowHeight: model.rowHeightM,
                vfov: model.vfovDeg,
                rows: model.targetRows,
                includeLeft: !!includeLeft,
                includeRight: !!includeRight
              })
              areaSwal.close()
            }

            const fnApplyAutoRowSpacing = function (forceOverwrite) {
              const useSplitDetect = $modal.find('[data-shadow-axis-split-detect]').is(':checked')
              const estimatedSpacing = fnResolveShadowRowSpacing(axisUpBearing, useSplitDetect)
              if (Number.isFinite(estimatedSpacing) && estimatedSpacing > 0) {
                if (forceOverwrite || !rowSpacingEdited) {
                  $modal.find('[data-shadow-row-spacing]').val(Number(estimatedSpacing).toFixed(1))
                }
                $modal.find('[data-shadow-height-warning]').addClass('d-none')
                return
              }
              if (forceOverwrite || !rowSpacingEdited) {
                $modal.find('[data-shadow-row-spacing]').val(Number(SHADOW_DEFAULTS.rowSpacingM).toFixed(1))
              }
              $modal.find('[data-shadow-height-warning]').removeClass('d-none')
            }

            const fnFetchShadowDemElevationRows = async function (providerKey, points) {
              const key = String(providerKey || '').trim()
              const rows = Array.isArray(points) ? points : []
              if (!key || !rows.length) return []
              if (key === 'localDEM') {
                const localState = (typeof window !== 'undefined') ? window.PORTAL_LOCAL_TERRAIN_STATE : null
                if (!localState || localState.active !== true) throw new Error('localDEM inactive')
                const localShiftMeters = fnToFiniteShadowElevationOrNull(
                  typeof localState.getVerticalShiftMeters === 'function'
                    ? localState.getVerticalShiftMeters()
                    : localState.verticalShiftMeters
                )
                const fnIsInsideLocalDem = function (row) {
                  if (typeof localState.containsLatLng !== 'function') return true
                  return localState.containsLatLng(row.lat, row.lng) === true
                }
                const fnIsLocalNoDataArtifact = function (shiftedValue, rawValue) {
                  const shifted = fnToFiniteShadowElevationOrNull(shiftedValue)
                  const raw = fnToFiniteShadowElevationOrNull(rawValue)
                  if (shifted === null || raw === null) return false
                  if (localShiftMeters === null || Math.abs(localShiftMeters) < 0.0001) return false
                  if (Math.abs(raw) > 0.0001) return false
                  return Math.abs(shifted + localShiftMeters) < 0.11
                }
                const fnBuildLocalRow = function (shiftedValue, rawValue) {
                  const shifted = fnToFiniteShadowElevationOrNull(shiftedValue)
                  if (shifted === null) {
                    return {
                      elevation: null,
                      provider: ''
                    }
                  }
                  if (fnIsLocalNoDataArtifact(shifted, rawValue)) {
                    return {
                      elevation: null,
                      provider: ''
                    }
                  }
                  return {
                    elevation: shifted,
                    provider: key
                  }
                }
                if (typeof localState.sampleElevations === 'function') {
                  const sampledValues = await localState.sampleElevations(rows, { resampling: 'nearest' })
                  const rawValues = (typeof localState.sampleElevationsRaw === 'function')
                    ? await localState.sampleElevationsRaw(rows, { resampling: 'nearest' })
                    : (typeof localState.sampleElevationRaw === 'function'
                        ? rows.map(function (row) {
                          return fnIsInsideLocalDem(row) ? localState.sampleElevationRaw(row.lat, row.lng) : null
                        })
                        : [])
                  return rows.map(function (row, idx) {
                    if (!fnIsInsideLocalDem(row)) return { elevation: null, provider: '' }
                    return fnBuildLocalRow(sampledValues[idx], rawValues[idx])
                  })
                }
                if (typeof localState.sampleElevationAsync === 'function') {
                  return Promise.all(rows.map(async function (row) {
                    if (!fnIsInsideLocalDem(row)) {
                      return {
                        elevation: null,
                        provider: ''
                      }
                    }
                    const rawValue = (typeof localState.sampleElevationRawAsync === 'function')
                      ? await localState.sampleElevationRawAsync(row.lat, row.lng, { resampling: 'nearest' })
                      : (typeof localState.sampleElevationRaw === 'function'
                          ? localState.sampleElevationRaw(row.lat, row.lng)
                          : null)
                    const shiftedValue = await localState.sampleElevationAsync(row.lat, row.lng, { resampling: 'nearest' })
                    return fnBuildLocalRow(shiftedValue, rawValue)
                  }))
                }
                if (typeof localState.sampleElevation === 'function') {
                  return rows.map(function (row) {
                    if (!fnIsInsideLocalDem(row)) return { elevation: null, provider: '' }
                    const shiftedValue = localState.sampleElevation(row.lat, row.lng)
                    const rawValue = (typeof localState.sampleElevationRaw === 'function')
                      ? localState.sampleElevationRaw(row.lat, row.lng)
                      : null
                    return fnBuildLocalRow(shiftedValue, rawValue)
                  })
                }
                throw new Error('localDEM sampler missing')
              }
              const response = await fetch('/api/dem-elevation', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  provider: key,
                  points: rows.map(function (row) {
                    return { lat: Number(row.lat), lng: Number(row.lng) }
                  })
                })
              })
              const payload = await response.json().catch(function () { return null })
              if (!response.ok) {
                throw new Error(String((payload && payload.error) || ('DEM proxy hiba: HTTP ' + response.status)))
              }
              const results = Array.isArray(payload && payload.results) ? payload.results : []
              return rows.map(function (_row, idx) {
                const value = fnToFiniteShadowElevationOrNull(results[idx] && results[idx].elevation)
                return {
                  elevation: value,
                  provider: value === null ? '' : key
                }
              })
            }

            const fnBuildShadowDemProfileSpec = function () {
              const providerKey = String($modal.find('[data-shadow-dem-provider]').val() || '').trim()
              if (!providerKey) return null
              const midpoint = fnResolveAxisLayerMidpointLatLng(axisLayer)
              if (!midpoint) return null
              const rowSpacingValue = fnReadPositiveNumber($modal.find('[data-shadow-row-spacing]'))
              const rowSpacingM = Number.isFinite(rowSpacingValue) ? rowSpacingValue : SHADOW_DEFAULTS.rowSpacingM
              const targetRowsRaw = Number(String($modal.find('[data-shadow-target-rows]').val() || '').trim())
              const targetRows = fnClampShadowTargetRows(targetRowsRaw)
              const halfRange = Math.max(2 * rowSpacingM, (targetRows + 2) * rowSpacingM)
              const rowHeightValue = fnReadPositiveNumber($modal.find('[data-shadow-row-height]'))
              const rowHeightM = Number.isFinite(rowHeightValue) ? rowHeightValue : SHADOW_DEFAULTS.rowHeightM
              const vfovValue = Number(String($modal.find('[data-shadow-vfov]').val() || '').trim())
              const vfovDeg = (Number.isFinite(vfovValue) && vfovValue > 0 && vfovValue < 89.9) ? vfovValue : SHADOW_DEFAULTS.vfovDeg
              const gimbalValue = Number(String($modal.find('[data-shadow-gimbal-pitch]').val() || '').trim())
              const gimbalPitchDeg = Number.isFinite(gimbalValue) ? (gimbalValue <= 0 ? gimbalValue : -Math.abs(gimbalValue)) : SHADOW_DEFAULTS.gimbalPitchDeg
              const halfFov = vfovDeg / 2
              const absUpper = Math.abs(gimbalPitchDeg + halfFov)
              const absLower = Math.abs(gimbalPitchDeg - halfFov)
              const tanUpper = Math.tan(absUpper * (Math.PI / 180))
              const tanLower = Math.tan(absLower * (Math.PI / 180))
              const cotUpper = 1 / tanUpper
              const cotLower = 1 / tanLower
              const spanFactor = cotUpper - cotLower
              const targetSpillM = rowHeightM * SHADOW_DEFAULTS.edgeMarginRatio
              const baseGroundSpanM = (Number.isFinite(spanFactor) && Math.abs(spanFactor) > 1e-8)
                ? ((((targetRows + 1) * rowSpacingM) + (2 * targetSpillM)) / spanFactor)
                : (rowSpacingM * (targetRows + 3))
              const terrainHalfRange = halfRange + Math.max(rowSpacingM * 4, baseGroundSpanM)
              const domainPadding = rowSpacingM * 2
              const xMin = -terrainHalfRange - domainPadding
              const xMax = terrainHalfRange + domainPadding
              const sampleCount = Math.max(17, Math.min(41, (targetRows * 4) + 9))
              const crossBearing = normalizeBearingDeg(axisUpBearing + 90)
              const samplePoints = []
              for (let idx = 0; idx < sampleCount; idx += 1) {
                const ratio = sampleCount <= 1 ? 0.5 : (idx / (sampleCount - 1))
                const x = xMin + ((xMax - xMin) * ratio)
                const moved = offsetLatLngByMeters(midpoint.lat, midpoint.lng, x, crossBearing)
                samplePoints.push({
                  x: x,
                  lat: Number(moved && moved.lat),
                  lng: Number(moved && moved.lng)
                })
              }
              const signature = JSON.stringify({
                providerKey: providerKey,
                midpointLat: Number(midpoint.lat).toFixed(6),
                midpointLng: Number(midpoint.lng).toFixed(6),
                axisUpBearing: Number(axisUpBearing).toFixed(2),
                rowSpacingM: Number(rowSpacingM).toFixed(2),
                targetRows: targetRows,
                xMin: Number(xMin).toFixed(2),
                xMax: Number(xMax).toFixed(2),
                sampleCount: sampleCount
              })
              return {
                providerKey: providerKey,
                signature: signature,
                samplePoints: samplePoints
              }
            }

            const fnBuildShadowDemProfile = function (providerKey, signature, samplePoints, elevations, centerElevationOverride) {
              const rows = (Array.isArray(samplePoints) ? samplePoints : []).map(function (row, idx) {
                const elevationRow = Array.isArray(elevations) ? elevations[idx] : null
                const elevation = fnToFiniteShadowElevationOrNull(
                  elevationRow && typeof elevationRow === 'object'
                    ? elevationRow.elevation
                    : elevationRow
                )
                const pointRow = row && typeof row === 'object' ? row : null
                return {
                  idx: idx,
                  x: Number(row && row.x),
                  elevation: elevation,
                  provider: String((elevationRow && elevationRow.provider) || '').trim(),
                  lat: fnToFiniteShadowElevationOrNull(pointRow && pointRow.lat),
                  lng: fnToFiniteShadowElevationOrNull(pointRow && pointRow.lng)
                }
              }).filter(function (row) {
                return Number.isFinite(row.x)
              }).sort(function (a, b) { return a.x - b.x })
              const finiteRows = rows.filter(function (row) {
                return row.elevation !== null
              }).sort(function (a, b) { return a.x - b.x })
              if (finiteRows.length < 2) return null
              let centerElevation = fnToFiniteShadowElevationOrNull(centerElevationOverride)
              if (centerElevation === null) {
                for (let i = 1; i < finiteRows.length; i += 1) {
                  const prev = finiteRows[i - 1]
                  const next = finiteRows[i]
                  if (!(0 >= prev.x && 0 <= next.x)) continue
                  const span = next.x - prev.x
                  const ratio = Math.abs(span) > 1e-9 ? ((0 - prev.x) / span) : 0
                  centerElevation = prev.elevation + ((next.elevation - prev.elevation) * ratio)
                  break
                }
              }
              if (centerElevation === null) {
                const centerRow = finiteRows.reduce(function (best, row) {
                  if (!best) return row
                  return Math.abs(row.x) < Math.abs(best.x) ? row : best
                }, null)
                centerElevation = centerRow ? centerRow.elevation : 0
              }
              const samples = rows.map(function (row) {
                return {
                  idx: row.idx,
                  x: row.x,
                  y: row.elevation === null ? null : (row.elevation - centerElevation),
                  elevation: row.elevation,
                  provider: row.provider,
                  lat: row.lat,
                  lng: row.lng
                }
              })
              const points = samples.filter(function (row) {
                return row.y !== null
              }).map(function (row) {
                return {
                  idx: row.idx,
                  x: row.x,
                  y: row.y,
                  elevation: row.elevation,
                  provider: row.provider,
                  lat: row.lat,
                  lng: row.lng
                }
              })
              return {
                ready: true,
                providerKey: providerKey,
                signature: signature,
                centerElevation: centerElevation,
                samples: samples,
                points: points
              }
            }

            const fnFetchShadowDemProfileBundle = async function (providerKey, signature, samplePoints) {
              const primaryKey = String(providerKey || '').trim()
              const fallbackKey = fnResolveShadowFallbackProviderKey(primaryKey)
              const primaryRows = await fnFetchShadowDemElevationRows(primaryKey, samplePoints)
              const fallbackRows = (Array.isArray(samplePoints) ? samplePoints : []).map(function () {
                return { elevation: null, provider: '' }
              })
              const mergedRows = primaryRows.map(function (row) {
                return {
                  elevation: fnToFiniteShadowElevationOrNull(row && row.elevation),
                  provider: String((row && row.provider) || '').trim()
                }
              })
              const missingIndexes = []
              mergedRows.forEach(function (row, idx) {
                if (fnToFiniteShadowElevationOrNull(row && row.elevation) !== null) return
                missingIndexes.push(idx)
              })
              if (fallbackKey && missingIndexes.length) {
                const fallbackPoints = missingIndexes.map(function (idx) {
                  return samplePoints[idx]
                })
                const fetchedFallbackRows = await fnFetchShadowDemElevationRows(fallbackKey, fallbackPoints)
                missingIndexes.forEach(function (originalIdx, localIdx) {
                  const fallbackRow = fetchedFallbackRows[localIdx] || null
                  const elevation = fnToFiniteShadowElevationOrNull(fallbackRow && fallbackRow.elevation)
                  if (elevation === null) return
                  mergedRows[originalIdx] = {
                    elevation: elevation,
                    provider: fallbackKey
                  }
                  fallbackRows[originalIdx] = {
                    elevation: elevation,
                    provider: fallbackKey
                  }
                })
              }
              const mergedProfile = fnBuildShadowDemProfile(primaryKey, signature, samplePoints, mergedRows)
              if (!mergedProfile) return null
              const centerElevation = fnToFiniteShadowElevationOrNull(mergedProfile.centerElevation)
              const primaryProfile = fnBuildShadowDemProfile(primaryKey, signature, samplePoints, primaryRows, centerElevation)
              const fallbackProfile = fallbackKey
                ? fnBuildShadowDemProfile(fallbackKey, signature, samplePoints, fallbackRows, centerElevation)
                : null
              return {
                ready: true,
                providerKey: primaryKey,
                fallbackProviderKey: fallbackKey,
                signature: signature,
                centerElevation: centerElevation === null ? 0 : centerElevation,
                mergedProfile: mergedProfile,
                primaryProfile: primaryProfile,
                fallbackProfile: fallbackProfile,
                missingIndexes: missingIndexes.slice(),
                usedFallback: !!(fallbackProfile && Array.isArray(fallbackProfile.points) && fallbackProfile.points.length >= 2)
              }
            }

            const fnEnsureShadowDemProfile = function () {
              const spec = fnBuildShadowDemProfileSpec()
              if (!spec) {
                if ($modal.data('shadowDemProfile') || $modal.data('shadowDemProfilePending')) {
                  fnLogShadowDemDebug('log', '[shadow-dem] clear profile', {
                    providerKey: '',
                    reason: 'no-provider'
                  })
                }
                $modal.removeData('shadowDemProfile')
                $modal.removeData('shadowDemProfilePending')
                $modal.removeData('shadowDemProfileErrorSignature')
                return
              }
              const pendingSignature = String($modal.data('shadowDemProfilePending') || '').trim()
              const errorSignature = String($modal.data('shadowDemProfileErrorSignature') || '').trim()
              const readyProfile = $modal.data('shadowDemProfile') || null
              const readySignature = String(readyProfile && readyProfile.signature || '').trim()
              if (pendingSignature === spec.signature || readySignature === spec.signature || errorSignature === spec.signature) return
              $modal.data('shadowDemProfilePending', spec.signature)
              $modal.removeData('shadowDemProfileErrorSignature')
              fnLogShadowDemDebug('log', '[shadow-dem] fetch start', {
                providerKey: spec.providerKey,
                fallbackProviderKey: fnResolveShadowFallbackProviderKey(spec.providerKey),
                signature: spec.signature,
                sampleCount: spec.samplePoints.length
              })
              fnFetchShadowDemProfileBundle(spec.providerKey, spec.signature, spec.samplePoints)
                .then(function (profileBundle) {
                  if (String($modal.data('shadowDemProfilePending') || '').trim() !== spec.signature) return
                  if (!profileBundle || !profileBundle.mergedProfile) {
                    fnLogShadowDemDebug('warn', '[shadow-dem] fetch finished without usable profile', {
                      providerKey: spec.providerKey,
                      fallbackProviderKey: fnResolveShadowFallbackProviderKey(spec.providerKey),
                      signature: spec.signature
                    })
                    $modal.removeData('shadowDemProfile')
                    $modal.removeData('shadowDemProfilePending')
                    $modal.data('shadowDemProfileErrorSignature', spec.signature)
                    fnRefreshShadowModel()
                    return
                  }
                  $modal.data('shadowDemProfile', profileBundle)
                  $modal.removeData('shadowDemProfilePending')
                  $modal.removeData('shadowDemProfileErrorSignature')
                  fnLogShadowDemDebug('log', '[shadow-dem] fetch success', {
                    providerKey: profileBundle.providerKey,
                    fallbackProviderKey: profileBundle.fallbackProviderKey,
                    signature: spec.signature,
                    centerElevation: profileBundle.centerElevation,
                    pointCount: Array.isArray(profileBundle.mergedProfile && profileBundle.mergedProfile.points) ? profileBundle.mergedProfile.points.length : 0,
                    primaryPointCount: Array.isArray(profileBundle.primaryProfile && profileBundle.primaryProfile.points) ? profileBundle.primaryProfile.points.length : 0,
                    fallbackPointCount: Array.isArray(profileBundle.fallbackProfile && profileBundle.fallbackProfile.points) ? profileBundle.fallbackProfile.points.length : 0,
                    missingIndexes: Array.isArray(profileBundle.missingIndexes) ? profileBundle.missingIndexes.slice() : [],
                    usedFallback: !!profileBundle.usedFallback
                  })
                  if (fnIsShadowDemDeepDebugEnabled()) {
                    fnLogShadowDemDebug('log', '[shadow-dem] fetch detail', {
                      providerKey: profileBundle.providerKey,
                      fallbackProviderKey: profileBundle.fallbackProviderKey,
                      signature: spec.signature,
                      merged: fnBuildShadowDemProfileDebugSummary(profileBundle.mergedProfile),
                      primary: fnBuildShadowDemProfileDebugSummary(profileBundle.primaryProfile),
                      fallback: fnBuildShadowDemProfileDebugSummary(profileBundle.fallbackProfile)
                    })
                  }
                  fnRefreshShadowModel()
                })
                .catch(function (error) {
                  if (String($modal.data('shadowDemProfilePending') || '').trim() !== spec.signature) return
                  fnLogShadowDemDebug('error', '[shadow-dem] fetch error', {
                    providerKey: spec.providerKey,
                    fallbackProviderKey: fnResolveShadowFallbackProviderKey(spec.providerKey),
                    signature: spec.signature,
                    message: String(error && error.message || error || '')
                  })
                  $modal.removeData('shadowDemProfile')
                  $modal.removeData('shadowDemProfilePending')
                  $modal.data('shadowDemProfileErrorSignature', spec.signature)
                  fnRefreshShadowModel()
                })
            }

            const fnRefreshShadowModel = function () {
              fnEnsureShadowDemProfile()
              const isManual = fnIsShadowManualMode()
              if (isManual) {
                const lastEdited = String($modal.attr('data-shadow-last-edited') || 'gm').trim().toLowerCase()
                fnSyncShadowGmAndDistance(lastEdited === 'do' ? 'do' : 'gm')
              }
              const model = fnRenderShadowPreview($modal)
              fnRenderShadowPhotoPreview($modal, model)
              fnRenderShadowCalculations($modal, axisUpBearing, model)
              fnLogShadowDemDebug('log', '[shadow-dem] refresh model', {
                demProviderKey: model && model.demProviderKey ? model.demProviderKey : '',
                demProviderLabel: fnGetShadowDemProviderLabel(model && model.demProviderKey ? model.demProviderKey : ''),
                demFallbackProviderKey: model && model.demFallbackProviderKey ? model.demFallbackProviderKey : '',
                demFallbackProviderLabel: fnGetShadowDemProviderLabel(model && model.demFallbackProviderKey ? model.demFallbackProviderKey : ''),
                valid: !!(model && model.valid),
                mode: model && model.mode ? model.mode : '',
                gm: model && Number.isFinite(Number(model.gm)) ? Number(model.gm) : null,
                rowSpacingM: model && Number.isFinite(Number(model.rowSpacingM)) ? Number(model.rowSpacingM) : null,
                rowHeightM: model && Number.isFinite(Number(model.rowHeightM)) ? Number(model.rowHeightM) : null,
                groundSpanM: model && Number.isFinite(Number(model.groundSpanM)) ? Number(model.groundSpanM) : null,
                demProfileApplied: !!(model && model.demProfileApplied),
                fallbackDemProfileApplied: !!(model && model.fallbackDemProfileApplied),
                note: 'A DEM provider kiválasztás terrain-profilt kér le; ha a provider válaszol, a shadow preview és a fő számolás már ezt a DEM vonalat használja.'
              })
              return model
            }
            const fnRotateShadowAxisQuarterTurn = function () {
              const centerLatLng = fnResolveAxisLayerMidpointLatLng(axisLayer)
              if (!centerLatLng) {
                Swal.showValidationMessage(fnT('shadow.invalid_axis'))
                return false
              }
              fnRotateAxisLayerAroundCenter(axisLayer, centerLatLng, 90)
              const nextBearing = fnResolveSeekAxisUpBearing(axisLayer)
              if (!Number.isFinite(nextBearing)) {
                Swal.showValidationMessage(fnT('shadow.invalid_axis'))
                return false
              }
              axisUpBearing = normalizeBearingDeg(nextBearing)
              fnApplyAutoRowSpacing(false)
              fnRefreshShadowModel()
              return true
            }

            $modal.attr('data-shadow-last-edited', 'gm')
            fnPopulateShadowDemProviderSelect($modal)
            fnApplyAutoRowSpacing(true)
            fnRefreshShadowModel()
            $modal.find('[data-shadow-mode]').on('change', function () {
              fnRefreshShadowModel()
            })
            $modal.find('[data-shadow-dem-provider]').on('change', function () {
              const providerKey = String($(this).val() || '').trim()
              fnLogShadowDemDebug('log', '[shadow-dem] select change', {
                providerKey: providerKey,
                providerLabel: fnGetShadowDemProviderLabel(providerKey)
              })
              fnRefreshShadowModel()
            })
            $modal.find('[data-shadow-gimbal-pitch],[data-shadow-row-spacing],[data-shadow-row-height],[data-shadow-vfov],[data-shadow-target-rows]').on('input', function () {
              $modal.find('[data-shadow-mode]').val('auto')
              if ($(this).is('[data-shadow-row-spacing]')) {
                rowSpacingEdited = true
              }
              fnRefreshShadowModel()
            })
            $modal.find('[data-shadow-gm]').on('input', function () {
              $modal.find('[data-shadow-mode]').val('manual')
              $modal.attr('data-shadow-last-edited', 'gm')
              fnRefreshShadowModel()
            })
            $modal.find('[data-shadow-drone-center-distance]').on('input', function () {
              $modal.find('[data-shadow-mode]').val('manual')
              $modal.attr('data-shadow-last-edited', 'do')
              fnRefreshShadowModel()
            })
            $modal.find('[data-shadow-axis-split-detect]').on('change', function () {
              const anchorLatLng = fnGetImportWaypointsCenter() || map.getCenter()
              const nextLayer = fnCreateSeekAxisLayer(anchorLatLng, {
                detectSplitRows: $(this).is(':checked'),
                ignoreAxisUpBearingLast: true,
                forceAutoAxis: true
              })
              if (!nextLayer) return
              if (drawnItems && axisLayer && drawnItems.hasLayer(axisLayer)) {
                drawnItems.removeLayer(axisLayer)
              }
              axisLayer = nextLayer
              if (drawnItems) {
                drawnItems.addLayer(axisLayer)
                drawnItems.addTo(map)
              }
              const nextBearing = fnResolveSeekAxisUpBearing(axisLayer)
              if (Number.isFinite(nextBearing)) {
                axisUpBearing = normalizeBearingDeg(nextBearing)
                fnApplyAutoRowSpacing(false)
                fnRefreshShadowModel()
              }
            })
            $modal.on('click', '[data-shadow-create-left]', function () {
              fnSubmitShadowCreate(true, false)
            })
            $modal.on('click', '[data-shadow-create-right]', function () {
              fnSubmitShadowCreate(false, true)
            })
            $(modal).on('click', '[data-shadow-create-both]', function () {
              fnSubmitShadowCreate(true, true)
            })
            $(modal).on('click', '[data-shadow-redraw-axis]', function () {
              areaSwal.close()
              fnCleanup()
              fnStartManualAxisDraw(fnOpenShadowPopup)
            })
            $(modal).on('click', '[data-shadow-rotate-axis-quarter]', function () {
              fnRotateShadowAxisQuarterTurn()
            })
            $(modal).on('click', '[data-shadow-cancel]', function () {
              areaSwal.close()
            })
          },
        }).finally(function () {
          fnCleanup()
        })
      }

      const autoAxisLayer = fnCreateSeekAxisLayer(null, { detectSplitRows: true })
      if (!autoAxisLayer) {
        Swal.fire(fnT('seek.axis_not_computable'))
        fnStartManualAxisDraw(fnOpenShadowPopup)
        return
      }
      fnOpenShadowPopup(autoAxisLayer)
    })
}

export {
  bindSeekUiHandlers
}
